export interface ServizioCdC {
  id: string;
  nome: string;
  descrizione: string;
  orari?: string[];
  contatti?: string[];
  accesso?: string;
  prestazioni?: string[];
  note?: string[];
}

export interface SezioneCdC {
  id: string;
  titolo: string;
  servizi: ServizioCdC[];
}

export interface CasaDellaComunita {
  nome: string;
  citta: string;
  indirizzo: string;
  sitoWeb?: string;
  sezioneTerritoriale?: string;
  sezioneDistrettuale?: string;
  attiva: number;
  posizione?: { lat: number; lng: number };
  sezioni: SezioneCdC[];
}

export const casaDellaCOmunitaVimercate: CasaDellaComunita = {
  nome: 'Casa della Comunità di Vimercate',
  citta: 'Vimercate (MB)',
  indirizzo: 'Via Giuditta Brambilla, 11 - Vimercate (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Vimercate',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6138, lng: 9.3697 },
  sezioni: [
    {
      id: 'front-office',
      titolo: 'Front-office, CUP prenotazioni CdC, Scelta e revoca Medico Medicina Generale',
      servizi: [
        {
          id: 'front-office-cdc',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Accoglienza, informazioni, prenotazioni e accettazioni; pratiche amministrative sanitarie per i cittadini.',
          orari: ['Da lunedì a venerdì non festivi: 08:00-20:00', 'Prenotazioni telefoniche: 14:00-20:00'],
          contatti: [
            'Tel. 039 6654447',
            'E-mail: front-office-cdc.vimercate@asst-brianza.it',
            'SIOC cittadino: sioc.asst-brianza.it',
            'Call center regionale: 800638638 (rete fissa) / 02999599 (rete mobile)',
            'Prenota online: https://prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
          prestazioni: [
            'Prenotazioni appuntamenti per ambulatori di medicina specialistica, diagnostica di base e IFeC',
            'Pagamento ticket (modalità elettronica)',
            'Rinnovo tessere sanitarie per utenti stranieri',
            'Domiciliazione sanitaria',
            'Iscrizioni al SSN',
            'Esenzioni per patologia, reddito, status e invalidità',
            'Scelta/revoca MMG e PLS',
            'Codici PIN/PUK e OTP per Fascicolo Sanitario Elettronico',
            'Consenso al fascicolo sanitario e alle notifiche in ambito sanitario',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-territoriale',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute; supporto all’attivazione dei servizi per cittadini fragili.',
          orari: ['Lunedì-venerdì non festivi: 09:00-16:00'],
          contatti: ['Tel. 039 6654448', 'E-mail: pua.vimercate@asst-brianza.it'],
          prestazioni: [
            'Attivazione servizi sociosanitari (es. ADI, misura B1, Dopo di Noi, residenzialità assistita religiosi)',
            'Informazioni su protesica e integrativa',
            'Raccolta domande correlate',
          ],
        },
        {
          id: 'cure-domiciliari',
          nome: 'Cure domiciliari',
          descrizione:
            'Prestazioni sociosanitarie integrate a domicilio per persone fragili/non autosufficienti, erogate da professionisti sanitari.',
          accesso: 'Servizio attivabile a cura di PUA/IFeC.',
          orari: ['Per informazioni: lunedì-venerdì non festivi 09:00-16:00'],
          contatti: ['Tel. 039 6654448', 'E-mail: pua.vimercate@asst-brianza.it'],
          prestazioni: [
            'Prelievi ematici',
            'Medicazioni',
            'Sostituzione catetere vescicale',
            'Gestione accessi vascolari e stomie',
            'Trattamenti riabilitativi',
          ],
        },
        {
          id: 'ifec',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Servizio infermieristico territoriale della Casa della Comunità, con accesso previa valutazione domanda presso PUA e prenotazione Front Office.',
          orari: ['Lunedì-domenica: 08:00-20:00', 'Punto prelievi (utenti già in carico CdC): lunedì-venerdì 08:00-09:00 su prenotazione CdC'],
          contatti: ['E-mail: amb.ifcvimercate@asst-brianza.it'],
        },
        {
          id: 'cot',
          nome: 'Centrale Operativa Territoriale (COT)',
          descrizione:
            'Funzione di supporto di back office al coordinamento della presa in carico di assistiti fragili e cronici nei diversi setting assistenziali.',
          note: [
            'Gestisce segnalazioni da presidi ospedalieri, strutture intermedie/riabilitazione, MMG e altri nodi della rete.',
            'Agevola la transizione ospedale-territorio/domicilio e territorio-strutture intermedie/Ospedale di Comunità.',
          ],
        },
      ],
    },
    {
      id: 'specialistica-primarie',
      titolo: 'Specialistica, diagnostica e cure primarie',
      servizi: [
        {
          id: 'medicina-specialistica',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Attività specialistica su impegnativa del medico curante, con prenotazione presso Front Office/CUP.',
          accesso: 'Con impegnativa del medico curante e prenotazione.',
          prestazioni: [
            'Cardiologia',
            'Diabetologia',
            'Epatologia',
            'Fisiatria',
            'Geriatria',
            'Medicina interna',
            'Neurologia',
            'Pneumologia (incluso ambulatorio contrasto tabagismo: accesso senza impegnativa con ticket)',
            'Reumatologia',
          ],
        },
        {
          id: 'ambulatorio-medico-diurno',
          nome: 'Ambulatorio Medico Diurno',
          descrizione:
            'Assistenza medica di primo livello, senza sostituire MMG/PLS; accesso tramite Numero Europeo Armonizzato 116117 e Centrale Unica Diurna.',
          orari: ['Attivo 7 giorni su 7: 08:00-20:00'],
          contatti: ['Numero unico: 116117 (contatto iniziale obbligatorio)'],
          note: [
            'La Centrale Unica può gestire consulto da remoto e invio all’ambulatorio più vicino con link SMS per scaricare relazione sanitaria.',
          ],
        },
        {
          id: 'continuita-assistenziale',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Assistenza sanitaria di medicina generale nelle ore notturne, prefestive e festive per bisogni non differibili.',
          contatti: ['Centrale operativa unica: 116117'],
          orari: [
            'CA Adulti (su prenotazione telefonica): lunedì-venerdì 20:00-24:00; sabato/domenica/prefestivi/festivi 08:00-24:00',
          ],
        },
        {
          id: 'continuita-assistenziale-pediatrica-vimercate',
          nome: 'Continuità Assistenziale Pediatrica',
          descrizione:
            'Assistenza sanitaria di medicina nelle ore notturne, prefestive e festive per bisogni non differibili.',
          contatti: ['Centrale operativa unica: 116117'],
          orari: [
            'CA Pediatrica (0-14 anni, su prenotazione telefonica): sabato 09:00-14:00 con gestione telefonica/televisita e possibile visita in sede CdC',
          ],
        }
      ],
    },
    {
      id: 'benessere-psicologico-sportelli',
      titolo: 'Benessere psicologico e sportelli',
      servizi: [
        {
          id: 'psicologia-cure-primarie-comunita',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio su bisogni psico-emotivi (ansia, depressione, eventi di vita), promozione benessere e agio psicologico con attenzione a bambini/adolescenti/genitori.',
          accesso: 'Libero e gratuito, senza impegnativa medica.',
          orari: ['Ambulatorio: lunedì-venerdì 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico orientato al potenziamento risorse personali',
            'Percorsi di terapia di gruppo',
          ],
          note: [
            'Nella mail indicare: nome, cognome, data di nascita, comune di residenza, MMG/PLS, motivo richiesta, contatti mail/telefono.',
          ],
        },
        {
          id: 'cvi',
          nome: 'Sportello Centro Vita Indipendente (CVI)',
          descrizione: 'Sportello in collaborazione con l’Ambito di Vimercate.',
          orari: ['Mercoledì 16:00-19:00', 'Primo sabato del mese su appuntamento'],
          contatti: ['E-mail: cvi.vimercate@offertasociale.it', 'Tel. 3714442559 (09:00-10:00)'],
        },
        {
          id: 'gap',
          nome: 'Sportello Gioco d’Azzardo patologico (GAP)',
          descrizione:
            'Sportello ad accesso libero, di ascolto, conoscenza e consulenza per problematiche legate a sostanze, alcol e comportamenti additivi, incluso gioco d’azzardo.',
        },
        {
          id: 'si-sportello-informatico',
          nome: 'Sportello Informatico (SI)',
          descrizione: 'Servizio in collaborazione con l’Ambito di Vimercate.',
          orari: ['Venerdì 13:30-18:30'],
          contatti: ['E-mail: sportello.si@offertasociale.it', 'Tel. 3716270215 (09:00-10:00)'],
        },
      ],
    },
    {
      id: 'segreteria-urp-servizi-territorio',
      titolo: 'Segreteria distrettuale e altri servizi del territorio',
      servizi: [
        {
          id: 'urp-distretto',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di contatto per informazioni e relazioni con il pubblico.',
          contatti: ['Tel. 039 6654870', 'E-mail: urp.distrvimercate@asst-brianza.it'],
        },
        {
          id: 'consultori-familiari',
          nome: 'Consultorio familiare',
          descrizione: 'Servizio ad accesso libero con tessera sanitaria.',
          prestazioni: [
            'Arcore - Via Umberto I, 17',
            'Concorezzo - Via Santa Marta, 18',
            'Vimercate - Via Armando Diaz, 42',
          ],
          note: ['Orari e prenotazioni differenziati per sede come da locandina CdC.'],
        },
        {
          id: 'mobilita-internazionale-ssn',
          nome: 'Mobilità internazionale e iscrizioni SSN',
          descrizione:
            'Servizi amministrativi distrettuali su appuntamento: iscrizioni volontarie SSN, dichiarazioni volontà donazione organi/tessuti, interdizione anticipata dal lavoro (maternità anticipata), domande rimborso/contributo spese per trattamenti dialitici.',
          orari: ['Lunedì-venerdì 09:00-12:30 (su appuntamento, in base al servizio)'],
          contatti: [
            'Tel. 039 6654874 / 039 6654873 (in base al servizio)',
            'E-mail: estero.vimercate@asst-brianza.it',
            'E-mail: segreteria.distrvimercate@asst-brianza.it',
          ],
        },
      ],
    },
  ],
};
export const casaDellaComunitaVimercate = casaDellaCOmunitaVimercate;

export const casaDellaCOmunitaBellusco: CasaDellaComunita = {
  nome: 'Casa della Comunità di Bellusco',
  citta: 'Bellusco (MB)',
  indirizzo: 'Corte dei Frati - Bellusco (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Vimercate',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6155, lng: 9.4152 },
  sezioni: [
    {
      id: 'front-office',
      titolo: 'Front-office, CUP prenotazioni CdC, Scelta e revoca Medico Medicina Generale',
      servizi: [
        {
          id: 'front-office-cdc-bellusco',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Accoglienza, informazioni, prenotazioni e accettazioni; pratiche amministrative sanitarie per i cittadini.',
          orari: ['Da lunedì a venerdì non festivi: 08:00-16:00', 'Prenotazioni telefoniche: 14:00-16:00'],
          contatti: [
            'Tel. 039 6654833',
            'E-mail: front-office-cdc.bellusco@asst-brianza.it',
            'SIOC cittadino: sioc.asst-brianza.it',
            'Call center regionale: 800638638 (rete fissa) / 02999599 (rete mobile)',
            'Prenota online: https://prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
          prestazioni: [
            'Prenotazioni appuntamenti per ambulatori di medicina specialistica, diagnostica di base e IFeC',
            'Rinnovo tessere sanitarie per utenti stranieri',
            'Domiciliazione sanitaria',
            'Iscrizioni al SSN',
            'Esenzioni per patologia, reddito, status e invalidità',
            'Scelta/revoca MMG e PLS',
            'Codici PIN/PUK e OTP per Fascicolo Sanitario Elettronico',
            'Consenso al fascicolo sanitario e alle notifiche in ambito sanitario',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-territoriale',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-bellusco',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute; supporto all’attivazione dei servizi per cittadini fragili.',
          orari: ['Lunedì-venerdì non festivi: 09:00-16:00'],
          contatti: ['Tel. 039 6654921', 'E-mail: pua.bellusco@asst-brianza.it'],
          prestazioni: [
            'Attivazione servizi sociosanitari (es. ADI, misura B1, Dopo di Noi, residenzialità assistita religiosi)',
            'Informazioni su protesica e integrativa',
            'Raccolta domande correlate',
          ],
        },
        {
          id: 'cure-domiciliari-bellusco',
          nome: 'Cure domiciliari',
          descrizione:
            'Prestazioni sociosanitarie integrate a domicilio per persone fragili/non autosufficienti, erogate da professionisti sanitari.',
          accesso: 'Servizio attivabile a cura di PUA/IFeC.',
          orari: ['Per informazioni: lunedì-venerdì non festivi 09:00-16:00'],
          contatti: ['Tel. 039 6654921', 'E-mail: pua.bellusco@asst-brianza.it'],
          prestazioni: [
            'Prelievi ematici',
            'Medicazioni',
            'Sostituzione catetere vescicale',
            'Gestione accessi vascolari e stomie',
            'Trattamenti riabilitativi',
          ],
        },
        {
          id: 'ifec-bellusco',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Servizio infermieristico territoriale della Casa della Comunità, con accesso previa valutazione domanda presso PUA e prenotazione Front Office.',
          orari: ['Lunedì-domenica: 08:00-20:00'],
          contatti: ['E-mail: amb.ifecbellusco@asst-brianza.it'],
          accesso: 'Accesso tramite valutazione della domanda presso il PUA e prenotazione presso il Front Office.',
        },
      ],
    },
    {
      id: 'specialistica-primarie',
      titolo: 'Specialistica, diagnostica e cure primarie',
      servizi: [
        {
          id: 'medicina-specialistica-bellusco',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Attività specialistica su impegnativa del medico curante, con prenotazione presso Front Office/CUP.',
          accesso: 'Con impegnativa del medico curante e prenotazione.',
          prestazioni: [
            'Angiologia',
            'Cardiologia',
            'Endocrinologia',
            'Medicina interna',
            'Neuropsicologia',
            'Otorinolaringoiatria',
            'Pneumologia',
            'Scienza dell’alimentazione',
            'Punto prelievi (lunedì-venerdì 07:30-09:30 con impegnativa MMG/PLS/specialista)',
          ],
        },
        {
          id: 'ambulatorio-medico-diurno-bellusco',
          nome: 'Ambulatorio Medico Diurno',
          descrizione:
            'Assistenza medica di primo livello, senza sostituire MMG/PLS; accesso tramite Numero Europeo Armonizzato 116117 e Centrale Unica Diurna.',
          orari: ['Attivo 7 giorni su 7: 08:00-20:00'],
          contatti: ['Numero unico: 116117 (contatto iniziale obbligatorio)'],
          note: [
            'La Centrale Unica può gestire consulto da remoto e invio all’ambulatorio più vicino con link SMS per scaricare relazione sanitaria.',
          ],
        },
        {
          id: 'continuita-assistenziale-bellusco',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Assistenza sanitaria di medicina generale e pediatria nelle ore notturne, prefestive e festive per bisogni non differibili.',
          contatti: ['Centrale operativa unica: 116117'],
          orari: ['Lunedì-venerdì 19:00-08:00', 'Sabato, domenica e festivi: H24'],
        },
      ],
    },
    {
      id: 'benessere-psicologico',
      titolo: 'Servizi per la promozione del benessere psicologico',
      servizi: [
        {
          id: 'psicologia-cure-primarie-comunita-bellusco',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio su bisogni psico-emotivi (ansia, depressione, eventi di vita), promozione benessere e agio psicologico con attenzione a bambini/adolescenti/genitori.',
          accesso: 'Libero e gratuito, senza impegnativa medica.',
          orari: ['Ambulatorio: lunedì-venerdì 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico orientato al potenziamento risorse personali',
            'Percorsi di terapia di gruppo',
          ],
          note: [
            'Nella mail indicare: nome, cognome, data di nascita, comune di residenza, MMG/PLS, motivo richiesta, contatti mail/telefono.',
          ],
        },
      ],
    },
    {
      id: 'segreteria-urp',
      titolo: 'Ufficio Relazioni con il Pubblico e segreteria distrettuale',
      servizi: [
        {
          id: 'urp-distretto-vimercate-bellusco',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di contatto per informazioni e relazioni con il pubblico.',
          contatti: ['Tel. 039 6654870', 'E-mail: urp.distrvimercate@asst-brianza.it'],
          note: ['Contatto riportato nella locandina della CdC di Bellusco.'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaBellusco = casaDellaCOmunitaBellusco;

export const casaDellaCOmunitaBesanaBrianza: CasaDellaComunita = {
  nome: 'Casa della Comunità di Besana Brianza',
  citta: 'Besana Brianza (MB)',
  indirizzo: 'Via Viarana, 38 - Besana Brianza (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Carate Brianza',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6992, lng: 9.2789 },
  sezioni: [
    {
      id: 'front-office',
      titolo: 'Front Office e Centri Unici di Prenotazione (CUP)',
      servizi: [
        {
          id: 'front-office-cdc-besana',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Sportello per informazioni, accoglienza, prenotazioni e accettazioni della Casa della Comunità.',
          orari: ['Da lunedì a venerdì: 08:00-16:00'],
          contatti: ['Tel. 0362 984562', 'E-mail: front-office-cdc.besana@asst-brianza.it'],
          prestazioni: [
            'Richiesta informazioni e accoglienza',
            'Prenotazione appuntamenti per ambulatori di medicina specialistica e diagnostica di base',
            'Prenotazione ambulatorio IFeC',
            'Pagamento ticket per prestazioni afferenti alla CdC',
            'Scelta e revoca Medico Medicina Generale MMG/PLS',
            'Gestione esenzioni per patologia, reddito e invalidità',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-territoriale',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-besana',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Servizio di accoglienza socio-sanitaria integrata per orientare gli utenti nella fruizione dei servizi socio-sanitari e socio-assistenziali.',
          orari: ['Da lunedì a venerdì: 09:00-16:00'],
          contatti: [
            'Tel. Infermiere di Famiglia: 0362 984541',
            'Tel. Assistente Sociale: 0362 984542',
            'E-mail: pua.besana@asst-brianza.it',
          ],
          prestazioni: [
            'Orientamento ai servizi socio-sanitari e socio-assistenziali',
            'Raccolta richieste per attivazione ADI',
            'Supporto per protesica, farmacia territoriale e servizi connessi',
            'Valutazione dei bisogni di salute e attivazione servizi per fragilità e cronicità',
          ],
        },
        {
          id: 'ifec-besana',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Ambulatorio dedicato all’assistenza di pazienti e caregiver che necessitano di interventi tecnico-infermieristici e di educazione all’auto-cura.',
          orari: ['Da lunedì a venerdì: 08:30-16:00'],
          contatti: ['Tel. 0362 984543', 'E-mail: amb.ifecbesana@asst-brianza.it'],
          accesso: 'Accesso su impegnativa MMG e prenotazione tramite Front Office e CUP.',
        },
        {
          id: 'cure-domiciliari-besana',
          nome: 'Cure domiciliari',
          descrizione:
            'Prestazioni sociosanitarie integrate a domicilio per persone in condizione di fragilità/non autosufficienza, erogate da professionisti sanitari.',
          orari: ['Da lunedì a venerdì: 08:30-16:00'],
          contatti: ['Tel. 0362 984545 / 0362 984546', 'E-mail: pua.besana@asst-brianza.it'],
          prestazioni: [
            'Prelievi ematici',
            'Medicazioni',
            'Sostituzione catetere vescicale',
            'Gestione accessi vascolari e stomie',
            'Trattamenti riabilitativi',
          ],
        },
      ],
    },
    {
      id: 'specialistica-primarie',
      titolo: 'Specialistica, diagnostica e continuità assistenziale',
      servizi: [
        {
          id: 'punto-prelievi-besana',
          nome: 'Punto prelievi',
          descrizione:
            'Servizio prelievi ad accesso diretto con impegnativa del MMG/PLS o Medico Specialista.',
          orari: ['Da lunedì a venerdì: 07:30-09:30'],
          contatti: ['Tel. Punto Prelievi: 0362 984512'],
          accesso: 'Accesso diretto senza prenotazione con impegnativa.',
        },
        {
          id: 'medicina-specialistica-besana',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG per favorire il confronto diretto tra medico di medicina generale e specialista, in ottica di presa in carico condivisa.',
          prestazioni: ['Pneumologia', 'Diabetologia', 'Epatologia', 'Cardiologia', 'Geriatria'],
          accesso: 'Accesso con impegnativa del medico curante e prenotazione presso il Front Office.',
        },
        {
          id: 'continuita-assistenziale-besana',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Postazione di continuità assistenziale attiva in fascia serale/notturna e nei giorni prefestivi/festivi.',
          orari: ['Lunedì-venerdì: 20:00-24:00', 'Prefestivi e festivi: 08:00-24:00'],
          contatti: ['Numero Europeo Armonizzato: 116117'],
          note: ['Per accedere è necessario telefonare preventivamente al 116117.'],
        },
      ],
    },
    {
      id: 'salute-mentale-benessere',
      titolo: 'Servizi per la salute mentale e benessere psicologico',
      servizi: [
        {
          id: 'neuropsichiatria-infantile-besana',
          nome: 'Neuropsichiatria infantile',
          descrizione:
            'Diagnosi e cura di patologie neurologiche, psichiatriche e neuropsicologiche dell’infanzia e adolescenza, inclusi disordini dello sviluppo.',
          orari: ['Prime visite: mercoledì 10:00-12:00 (anche telefoniche)', 'Prime visite: giovedì 09:00-11:00 (anche telefoniche)'],
          contatti: ['Tel. 0362 984551', 'E-mail: uonpia.besana@asst-brianza.it'],
        },
        {
          id: 'ctpe-besana',
          nome: 'Comunità terapeutica per adolescenti (CTPE)',
          descrizione:
            'Struttura educativo-terapeutica-riabilitativa per adolescenti, finalizzata alla presa in carico in situazioni che richiedono parziale discontinuità dal contesto di vita.',
          contatti: ['Tel. 0362 984521', 'E-mail: ctpse.besana@asst-brianza.it'],
        },
        {
          id: 'cps-besana',
          nome: 'Centro Psico Sociale (CPS)',
          descrizione:
            'Servizio per visite psichiatriche e presa in carico di cittadini con disturbi mentali gravi, con gestione del piano di trattamento individuale.',
          orari: ['Da lunedì a venerdì: 08:30-16:00', 'Mercoledì chiuso al pubblico: 13:30-16:00'],
          contatti: ['Tel. 0362 984577', 'E-mail: cps.besana@asst-brianza.it'],
          note: ['Prevalentemente per appuntamento o con impegnativa MMG; possibile anche accesso diretto.'],
        },
        {
          id: 'psicologia-comunita-besana',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio dedicato ai bisogni psicologici di adulti e bambini con disturbi emotivi comuni e difficoltà legate agli eventi di vita.',
          orari: ['Prenotazione tramite Front Office: lunedì-venerdì 08:00-16:00'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          accesso: 'Accesso su impegnativa MMG/PLS.',
        },
      ],
    },
    {
      id: 'altri-servizi-territorio',
      titolo: 'Altri servizi del territorio',
      servizi: [
        {
          id: 'alzheimer-terzo-settore-besana',
          nome: 'Alzheimer (collaborazione con Terzo Settore)',
          descrizione:
            'Collaborazione con associazione di volontariato del territorio per supporto ai caregiver e informazione sui temi Alzheimer.',
          orari: ['Da lunedì a venerdì: 08:30-16:00'],
          contatti: ['Tel. 0362 984542', 'E-mail: pua.besana@asst-brianza.it'],
        },
        {
          id: 'scelta-revoca-besana',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Servizi amministrativi sanitari disponibili online o su appuntamento allo sportello CdC.',
          contatti: [
            'SIOC Cittadino: https://sioc.asst-brianza.it',
            'Numero verde regionale: 800.638.638',
            'Numero da mobile: 02.99.95.99',
            'Prenota online: https://prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
          prestazioni: [
            'Iscrizioni al Servizio Sanitario Regionale',
            'Esenzioni per patologia, reddito, status e invalidità',
            'Scelta e revoca Medico Medicina Generale del Medico di Medicina Generale e Pediatra di Libera Scelta',
            'Codici PIN/PUK',
            'Codici OTP',
          ],
        },
        {
          id: 'urp-carate-besana',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Besana Brianza.',
          contatti: ['Tel. 0362 984979', 'E-mail: urp.distrcarate@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaBesanaBrianza = casaDellaCOmunitaBesanaBrianza;

export const casaDellaCOmunitaBrugherio: CasaDellaComunita = {
  nome: 'Casa della Comunità di Brugherio',
  citta: 'Brugherio (MB)',
  indirizzo: 'Viale Lombardia, 270 - Brugherio (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Monza',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.5530, lng: 9.2880 },
  sezioni: [
    {
      id: 'presentazione-cdc-brugherio',
      titolo: 'La Casa di Comunità',
      servizi: [
        {
          id: 'ruolo-cdc-brugherio',
          nome: 'Punto unico di riferimento per la salute',
          descrizione:
            'La Casa della Comunità è il punto di accesso ai servizi sanitari e sociosanitari del territorio.',
          prestazioni: [
            'Percorso di cure personalizzato',
            'Accesso integrato all’assistenza sanitaria, sociosanitaria e socioassistenziale',
            'Presa in carico delle cronicità',
            'Valutazione a 360° del bisogno di salute grazie a un team di professionisti medici e sanitari',
          ],
          contatti: [
            'URP Distretto Monza: Tel. 039 6657836',
            'E-mail: urp.distrmonza@asst-brianza.it',
          ],
        },
      ],
    },
    
    {
      id: 'presa-in-carico-territoriale-brugherio',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-brugherio',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute della persona; supporto nell’attivazione dei servizi per cittadini che vivono in situazione di fragilità con necessità di presa in carico dalla rete dei servizi sociosanitari.',
          orari: ['Accesso libero: da lunedì a venerdì 08:00-16:00'],
          contatti: ['Tel. 039 6657808', 'E-mail: pua.brugherio@asst-brianza.it'],
          prestazioni: [
            'Raccolta richieste di attivazione di Assistenza Domiciliare Integrata (ADI)',
            'Orientamento su protesica e farmacia territoriale',
          ],
        },
        {
          id: 'cure-domiciliari-brugherio',
          nome: 'Cure domiciliari',
          descrizione:
            'Accompagnamento all’attivazione dei servizi di assistenza domiciliare attraverso il PUA.',
          orari: ['Attivazione tramite PUA: da lunedì a venerdì 08:00-16:00'],
          contatti: ['Tel. 039 6657808', 'E-mail: pua.brugherio@asst-brianza.it'],
        },
        {
          id: 'ifec-brugherio',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Al domicilio o presso l’ambulatorio, svolge attività di individuazione, presa in carico, monitoraggio e follow-up delle persone ritenute a rischio, fragili e/o con patologie croniche.',
          orari: ['Tutti i giorni, compresi sabato e domenica: 08:00-20:00'],
          contatti: ['Tel. 039 66578067821', 'E-mail: pua.brugherio@asst-brianza.it'],
          accesso:
            'Accesso tramite valutazione della domanda presso il PUA; oppure con impegnativa MMG (con codice e dicitura “Casa di Comunità”) e prenotazione presso il Front Office e CUP.',
          prestazioni: [
            'Assistenza a pazienti e caregiver con interventi tecnico-infermieristici',
            'Educazione all’auto-cura',
            'Ambulatorio infermieristico medicazioni',
          ],
        },
      ],
    },
    {
      id: 'specialistica-e-continuita-brugherio',
      titolo: 'Specialistica, diagnostica e continuità assistenziale',
      servizi: [
        {
          id: 'ambulatorio-medico-diurno-brugherio',
          nome: 'Continuità Assistenziale',
          descrizione:
            'L’Ambulatorio Medico Diurno garantisce assistenza medica di primo livello senza sostituire MMG/PLS. In ASST Brianza l’accesso avviene contattando il Numero Europeo Armonizzato 116117 e la Centrale Unica Diurna orienta verso consulto remoto, eventuale prescrizione e invio all’ambulatorio più vicino.',
          orari: [
            'Ambulatorio Medico Diurno: 7 giorni su 7, 08:00-20:00',
            'Numero 116117 (Centrale Unica Diurna): 7 giorni su 7, 08:00-19:00',
            'Continuità Assistenziale: dalle 20:00 alle 08:00 dal lunedì al venerdì e H24 sabato, domenica, prefestivi e festivi infrasettimanali',
          ],
          contatti: ['Numero unico: 116117'],
          note: [
            'La Centrale Unica Diurna consente consulto medico da remoto (anche in videochiamata) e rilascio di eventuale prescrizione dematerializzata.',
            'Tutti gli assistiti ricevono via SMS uno specifico link per scaricare la relazione sanitaria.',
            'Per la continuità assistenziale si accede sempre contattando il numero 116117.',
          ],
        },
        {
          id: 'medicina-specialistica-brugherio',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista, per una presa in carico condivisa.',
          prestazioni: [
            'Cardiologia',
            'Geriatria',
            'Neurologia',
            'Otorinolaringoiatria',
            'Pneumologia',
          ],
          accesso: 'Con impegnativa del medico curante e prenotazione presso Front-office o CUP.',
        },
      ],
    },
  ],
};

export const casaDellaComunitaBrugherio = casaDellaCOmunitaBrugherio;

export const casaDellaCOmunitaCesanoMaderno: CasaDellaComunita = {
  nome: 'Casa della Comunità di Cesano Maderno',
  citta: 'Cesano Maderno (MB)',
  indirizzo: 'Via San Carlo, 2 - Cesano Maderno (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Desio',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6286, lng: 9.1497 },
  sezioni: [
    {
      id: 'front-office-cup-cesano',
      titolo: 'Front-office, CUP e amministrativi',
      servizi: [
        {
          id: 'front-office-cdc-cesano',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Richiesta informazioni, prenotazione appuntamenti per ambulatori di medicina specialistica e diagnostica di base e ambulatorio IFeC; pagamento ticket (se dovuto) per prestazioni afferenti alla CdC; accettazione e prenotazione prelievi ematici.',
          orari: ['Da lunedì a venerdì: 08:00-16:00'],
          contatti: [
            'Tel. 0362 383751',
            'E-mail: front-office-cdc.cesano@asst-brianza.it',
          ],
        },
        {
          id: 'scelta-revoca-cesano',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Gestione Scelta e revoca Medico Medicina Generale MMG e servizi amministrativi attraverso canali online regionali e SIOC cittadino.',
          contatti: [
            'Sportello Istanze Online Cittadino (SIOC): https://sioc.asst-brianza.it',
            'Numero verde regionale: 800.638.638 (rete fissa)',
            'Numero da rete mobile: 02.99.95.99',
            'Prenota online: https://www.prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
        },
      ],
    },
    {
      id: 'servizi-territoriali-cesano',
      titolo: 'Servizi territoriali e prevenzione',
      servizi: [
        {
          id: 'consultorio-cesano',
          nome: 'Consultorio familiare',
          descrizione:
            'Interventi di prevenzione e assistenza sanitaria, psicologica e sociale a tutela della salute della donna, della coppia e della famiglia.',
          accesso: 'Accesso libero.',
          orari: [
            'Lunedì: 09:00-12:00',
            'Giovedì: 09:00-12:00 e 14:00-16:00',
            'Venerdì: 09:00-12:00',
          ],
          contatti: ['Tel. 0362 383743', 'E-mail: consultorio.cesano@asst-brianza.it'],
        },
        {
          id: 'vaccinazioni-cesano',
          nome: 'Vaccinazioni',
          descrizione: 'Informazioni e prenotazioni tramite portale vaccinale ASST Brianza.',
          contatti: ['https://sv.asst-brianza.it', 'Vaccinazioni internazionali: https://sv.asst-brianza.it/'],
        },
        {
          id: 'punto-prelievi-cesano',
          nome: 'Punto prelievi',
          descrizione: 'Servizio prelievi ad accesso libero con impegnativa.',
          orari: ['Da lunedì a venerdì: 07:30-09:30'],
        },
      ],
    },
    {
      id: 'presa-in-carico-cesano',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-cesano',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accesso diretto dell’utente e/o caregiver per orientamento e valutazione integrata socio-sanitaria del bisogno di salute; supporto nell’attivazione dei servizi per i cittadini in situazione di fragilità e valutazione/gestione delle richieste di cure domiciliari.',
          orari: ['Apertura al pubblico: da lunedì a venerdì 08:30-16:00'],
          contatti: ['Tel. 0362 383726', 'E-mail: pua.cesano@asst-brianza.it'],
        },
        {
          id: 'ifec-cesano',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Ambulatorio dedicato all’assistenza dei pazienti e dei caregiver che necessitano di interventi tecnico-infermieristici e interventi educativi finalizzati all’apprendimento di competenze e comportamenti utili al mantenimento e alla promozione del proprio stato di salute.',
          orari: ['Da lunedì a venerdì: 08:30-16:00'],
          contatti: ['Tel. 0362 383757', 'E-mail: amb.ifccesano@asst-brianza.it'],
          accesso: 'Accesso con impegnativa e prenotazione presso Front Office (da lunedì a venerdì 08:00-16:00).',
        },
      ],
    },
    {
      id: 'specialistica-cesano',
      titolo: 'Specialistica e diagnostica ambulatoriale',
      servizi: [
        {
          id: 'medicina-specialistica-cesano',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista, per una presa in carico condivisa.',
          prestazioni: [
            'Otorinolaringoiatria',
            'Geriatria',
            'Diabetologia',
            'Reumatologia',
            'Medicina interna',
            'Pneumologia',
            'Ecografie tiroide e addome',
          ],
          accesso: 'Accesso con impegnativa del medico curante e prenotazione presso Front Office/CUP.',
          contatti: [
            'Prenotazioni CUP: da lunedì a venerdì 08:00-16:00',
            'Numero verde: 800.638.638',
            'Numero mobile: 02.999.599 (da lunedì a sabato 08:00-20:00)',
            'Prenota online: https://www.prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
        },
      ],
    },
    {
      id: 'salute-mentale-psicologia-cesano',
      titolo: 'Servizi per la salute mentale',
      servizi: [
        {
          id: 'neuropsichiatria-infantile-cesano',
          nome: 'Neuropsichiatria infantile - Progetti Regionali Innovativi',
          descrizione:
            'Servizi rivolti ad adolescenti, minori migranti, disturbi dell’apprendimento, autismo e disturbo dell’attività e dell’attenzione; accesso su richiesta dei servizi territoriali di neuropsichiatria.',
          orari: ['Contatto telefonico: martedì 09:45-11:00'],
          contatti: ['Tel. 0362 383952', 'E-mail: uonpia.bovisio@asst-brianza.it'],
        },
        {
          id: 'psicologia-cure-primarie-cesano',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio dedicato ai bisogni psico-emotivi (difficoltà emotive, condizioni ansioso-depressive, difficoltà legate agli eventi di vita) e alla promozione del benessere psicologico con attenzione a bambini, adolescenti e genitori.',
          accesso: 'Accesso libero e gratuito, senza impegnativa, scrivendo una mail al servizio.',
          orari: ['Ambulatorio: da lunedì a venerdì 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico mirato al potenziamento delle risorse personali',
            'Percorsi di terapia di gruppo',
          ],
          note: [
            'Nella mail indicare: nome, cognome, data di nascita, comune di residenza, medico/pediatra di riferimento, motivo richiesta, contatti mail e telefonico.',
          ],
        },
      ],
    },
    {
      id: 'protesica-invalidita-urp-cesano',
      titolo: 'Protesica, invalidità e URP',
      servizi: [
        {
          id: 'protesica-invalidita-cesano',
          nome: 'Protesica e invalidità',
          descrizione: 'Servizi dedicati a protesica maggiore/minore, ausili per assorbenza e pratiche di invalidità.',
          contatti: [
            'Protesica maggiore: Tel. 0362 385940 - E-mail: protesica.desio@asst-brianza.it',
            'Protesica minore: Tel. 0362 385331 - E-mail: ausili.desio@asst-brianza.it',
            'Ausili per assorbenza / Ufficio invalidi: Tel. 0362 385929',
            'E-mail assorbenza: assorbenza.desio@asst-brianza.it',
            'E-mail invalidi: invalidi.distrdesio@asst-brianza.it',
          ],
          orari: ['Martedì e giovedì 09:00-12:00 (contatti dedicati di protesica).'],
        },
        {
          id: 'urp-desio-cesano',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Cesano Maderno.',
          contatti: ['Tel. 0362 385923-924', 'E-mail: urp.distrdesio@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaCesanoMaderno = casaDellaCOmunitaCesanoMaderno;

export const casaDellaCOmunitaDesio: CasaDellaComunita = {
  nome: 'Casa della Comunità di Desio',
  citta: 'Desio (MB)',
  indirizzo: 'Via Ugo Foscolo, 24 - Desio (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Desio',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6208, lng: 9.2095 },
  sezioni: [
    {
      id: 'front-office-cup-desio',
      titolo: 'Front-office, CUP e amministrativi',
      servizi: [
        {
          id: 'front-office-cdc-desio',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Richiesta informazioni, prenotazione appuntamenti per ambulatori di medicina specialistica e diagnostica di base e ambulatorio IFeC; pagamento ticket (se dovuto) per prestazioni afferenti alla CdC; accettazione e prenotazione prelievi ematici.',
          orari: [
            'Sportello aperto: da lunedì a venerdì 08:00-16:00',
            'Contatto telefonico: da lunedì a venerdì 13:30-15:30',
          ],
          contatti: ['Tel. 0362 385909-10', 'E-mail: front-office-cdc.desio@asst-brianza.it'],
        },
        {
          id: 'scelta-revoca-desio',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Gestione Scelta e revoca Medico Medicina Generale MMG ed esenzioni per patologia attraverso canali online regionali e SIOC cittadino.',
          contatti: [
            'Sportello Istanze Online Cittadino (SIOC): https://sioc.asst-brianza.it',
            'Numero verde regionale: 800.638.638 (rete fissa)',
            'Numero da rete mobile: 02.99.95.99',
            'Prenota online: https://www.prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-territoriale-desio',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-desio',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accesso diretto dell’utente e/o caregiver per orientamento e valutazione integrata socio-sanitaria del bisogno di salute; supporto nell’attivazione dei servizi per i cittadini in situazione di fragilità e valutazione/gestione delle richieste relative alle cure domiciliari.',
          orari: [
            'Lunedì, mercoledì e venerdì: 08:30-13:00',
            'Martedì e giovedì: 13:30-16:00',
          ],
          contatti: [
            'Tel. Infermiere di Famiglia e Comunità: 0362 385902',
            'Tel. Assistente Sociale: 0362 385903',
            'Tel. Cure domiciliari: 0362 385902',
            'E-mail: pua.desio@asst-brianza.it',
          ],
        },
        {
          id: 'ifec-desio',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Ambulatorio dedicato all’assistenza dei pazienti e dei caregiver che necessitano di interventi tecnico-infermieristici e di interventi educativi finalizzati all’apprendimento di competenze e comportamenti utili al mantenimento e alla promozione del proprio stato di salute.',
          orari: ['Dal lunedì al venerdì: 10:00-13:00'],
          contatti: ['Tel. 0362 385901', 'E-mail: pua.desio@asst-brianza.it'],
          accesso: 'Accesso su impegnativa MMG/Medico Specialista e prenotazione presso Front-office CdC.',
        },
      ],
    },
    {
      id: 'specialistica-diagnostica-desio',
      titolo: 'Specialistica e diagnostica ambulatoriale',
      servizi: [
        {
          id: 'punto-prelievi-desio',
          nome: 'Punto prelievi',
          descrizione: 'Servizio prelievi ad accesso libero con impegnativa.',
          orari: ['Dal lunedì al venerdì: 07:30-09:30'],
        },
        {
          id: 'medicina-specialistica-desio',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista, per una presa in carico condivisa.',
          prestazioni: ['Geriatria', 'Diabetologia', 'Reumatologia'],
          accesso: 'Accesso con impegnativa del medico curante e prenotazione presso il Front-office.',
        },
      ],
    },
    {
      id: 'protesica-invalidita-desio',
      titolo: 'Protesica e invalidità',
      servizi: [
        {
          id: 'protesica-invalidita-desio-servizi',
          nome: 'Protesica e invalidità',
          descrizione: 'Accesso telefonico o via e-mail ai servizi dedicati del Distretto di Desio.',
          orari: ['Protesica maggiore/minore: martedì e giovedì 09:00-12:00'],
          contatti: [
            'Protesica maggiore: Tel. 0362 385940 - E-mail: protesica.desio@asst-brianza.it',
            'Protesica minore: Tel. 0362 385331 - E-mail: ausili.desio@asst-brianza.it',
            'Ausili per assorbenza: Tel. 0362 385929 - E-mail: assorbenza.desio@asst-brianza.it',
            'Ufficio invalidi: Tel. 0362 385928 (numero da OCR, verificare) - E-mail: invalidi.distrdesio@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'consultorio-psicologia-desio',
      titolo: 'Consultorio familiare e Psicologia delle Cure Primarie e di Comunità',
      servizi: [
        {
          id: 'consultorio-familiare-desio',
          nome: 'Consultorio familiare',
          descrizione:
            'Interventi di prevenzione e assistenza sanitaria, psicologica e sociale a tutela della salute della donna, della coppia e della famiglia.',
          orari: [
            'Segreteria: lunedì 09:00-13:00 e 14:00-16:00',
            'Segreteria: mercoledì 09:00-13:00',
            'Segreteria: venerdì 09:00-13:00 e 14:00-16:00',
            'Prenotazioni telefoniche (Tel. 0362 383746): lunedì 14:00-16:00, mercoledì 09:00-13:00, venerdì 09:00-13:00',
          ],
          contatti: ['E-mail: consultorio.desio@asst-brianza.it'],
        },
        {
          id: 'psicologia-cure-primarie-desio',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio dedicato ai bisogni psico-emotivi (difficoltà emotive, condizioni ansioso-depressive, difficoltà legate agli eventi di vita) e alla promozione del benessere psicologico con particolare attenzione a bambini, adolescenti e genitori.',
          accesso: 'Accesso libero e gratuito, senza impegnativa, scrivendo una mail al servizio.',
          orari: ['Ambulatorio: da lunedì a venerdì 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico mirato al potenziamento delle risorse personali',
            'Percorsi di terapia di gruppo',
          ],
          note: [
            'Nella mail indicare: nome, cognome, data di nascita, comune di residenza, medico/pediatra di riferimento, motivo richiesta, contatti mail e telefonico.',
          ],
        },
      ],
    },
    {
      id: 'ambulatorio-medico-diurno-desio',
      titolo: 'Continuità Assistenziale',
      servizi: [
        {
          id: 'amd-ca-desio',
          nome: 'Continuità Assistenziale',
          descrizione:
            'L’Ambulatorio Medico Diurno garantisce assistenza medica di primo livello senza sostituire MMG/PLS. In ASST Brianza i cittadini residenti e non residenti con domiciliazione sanitaria in provincia di Monza e Brianza accedono tramite numero 116117 e Centrale Unica Diurna.',
          orari: [
            'Ambulatorio Medico Diurno: 7 giorni su 7, 08:00-20:00',
            'Numero 116117 (Centrale Unica Diurna): 7 giorni su 7, 08:00-19:00',
            'Continuità assistenziale: dalle 20:00 alle 08:00 dal lunedì al venerdì e H24 sabato, domenica, prefestivi e festivi infrasettimanali',
          ],
          contatti: ['Numero unico: 116117'],
          note: [
            'La Centrale Unica Diurna gestisce consulto telefonico/videochiamata, eventuale prescrizione dematerializzata e invio all’ambulatorio più vicino.',
            'Gli assistiti ricevono via SMS un link per scaricare la relazione sanitaria.',
          ],
        },
      ],
    },
    {
      id: 'urp-desio',
      titolo: 'Ufficio Relazioni con il Pubblico',
      servizi: [
        {
          id: 'urp-desio-main',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Desio.',
          contatti: ['Tel. 0362 385923-924', 'E-mail: urp.distrdesio@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaDesio = casaDellaCOmunitaDesio;

export const casaDellaCOmunitaGiussano: CasaDellaComunita = {
  nome: 'Casa della Comunità di Giussano',
  citta: 'Giussano (MB)',
  indirizzo: 'Via Milano, 65 - Giussano (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Seregno',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6997, lng: 9.2122 },
  sezioni: [
    {
      id: 'accoglienza-cup-giussano',
      titolo: 'Accoglienza, CUP e pratiche amministrative',
      servizi: [
        {
          id: 'accoglienza-cup-giussano-main',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Accoglienza, informazioni, accettazione e prenotazioni; scelta/revoca MMG, esenzioni per patologia/reddito/invalidità e scelta del medico di base per pazienti fragili.',
          orari: [
            'Scelta/revoca ed esenzioni: da lunedì a venerdì 09:00-12:00 (accesso libero)',
            'Accoglienza-CUP: da lunedì a venerdì 08:00-20:00 (accesso libero)',
            'Contatto telefonico informativo: 0362 485031 da lunedì a venerdì 13:30-15:30',
          ],
          contatti: ['Tel. 0362 485031', 'E-mail: front-office-cdc.giussano@asst-brianza.it'],
        },
      ],
    },
    {
      id: 'presa-in-carico-giussano',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-giussano',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute della persona; supporto nell’attivazione dei servizi per cittadini fragili e presa in carico nella rete sociosanitaria.',
          accesso: 'Accesso libero.',
          orari: [
            'Da lunedì a venerdì: 09:00-13:00',
            'Mercoledì: anche pomeriggio 13:30-16:00',
          ],
          contatti: [
            'Tel. 0362 485073 - 0362 485009',
            'E-mail: pua.giussano@asst-brianza.it',
          ],
        },
        {
          id: 'ifec-giussano',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Assistenza alle persone e caregiver che necessitano di interventi infermieristici tecnico-assistenziali e di educazione alla salute, in raccordo con MMG/PLS.',
          orari: ['Ambulatorio infermieristico: da lunedì a venerdì 08:30-16:00'],
          contatti: ['Tel. 0362 485256', 'E-mail: amb.ifcgiussano@asst-brianza.it'],
          accesso: 'Con impegnativa e prenotazione presso Accoglienza-CUP.',
        },
        {
          id: 'assistenza-domiciliare-giussano',
          nome: 'Cure domiciliari',
          descrizione: 'Accompagnamento all’attivazione dei servizi di assistenza domiciliare.',
          accesso: 'Attivazione attraverso il PUA.',
          contatti: ['Tel. 0362 485073 - 0362 485009', 'E-mail: pua.giussano@asst-brianza.it'],
        },
      ],
    },
    {
      id: 'specialistica-giussano',
      titolo: 'Specialistica, diagnostica e ambulatori territoriali',
      servizi: [
        {
          id: 'punto-prelievi-giussano',
          nome: 'Punto prelievi',
          descrizione: 'Servizio prelievi ad accesso libero con impegnativa.',
          orari: ['Da lunedì a venerdì: 07:30-10:30'],
        },
        {
          id: 'medicina-specialistica-giussano',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche orientate a facilitare il confronto diretto tra Medico di Medicina Generale e specialista, per una presa in carico condivisa.',
          prestazioni: [
            'Cardiologia',
            'Fisiatria',
            'Ortopedia',
            'Neurologia',
            'Epatologia',
            'Diagnostica radiologica di base',
          ],
          accesso: 'Con impegnativa e prenotazione presso Accoglienza-CUP.',
          contatti: [
            'Sportello Accoglienza-CUP: da lunedì a venerdì 08:00-20:00',
            'Tel. 0362 485031',
            'Numero verde: 800.638.638',
            'Numero mobile: 02.999.599 (da lunedì a sabato 08:00-20:00)',
            'Prenota online: www.prenotasalute.regione.lombardia.it',
            'Farmacie del territorio aderenti',
          ],
        },
        
      ],
    },
    {
      id: 'salute-mentale-benessere-giussano',
      titolo: 'Salute mentale e benessere psicologico',
      servizi: [
        {
          id: 'neuropsichiatria-giussano',
          nome: 'Neuropsichiatria infantile - Progetti Regionali Innovativi',
          descrizione:
            'Servizi per adolescenti, minori migranti, disturbi dell’apprendimento, autismo e disturbo dell’attività e dell’attenzione.',
          accesso: 'Accesso su richiesta dei Servizi territoriali di Neuropsichiatria.',
        },
        {
          id: 'psicologia-comunita-giussano',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio di primo accesso per bisogni psicologici dei cittadini e disturbi emotivi comuni (difficoltà emotive, lievi condizioni ansioso-depressive, difficoltà legate agli eventi di vita).',
          accesso: 'Accesso con impegnativa e prenotazione presso Accoglienza-CUP.',
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
        },
        {
          id: 'gap-giussano',
          nome: 'Sportello Gioco d’Azzardo patologico (GAP)',
          descrizione: 'Sportello dedicato al supporto su problematiche legate al gioco d’azzardo patologico.',
          accesso: 'Accesso libero.',
          orari: ['Lunedì 13:00-17:00'],
          contatti: [
            'E-mail: gap.giussano@asst-brianza.it',
            'Tel. 0362 984813 (lunedì e giovedì 08:30-13:00)',
            'Tel. 039 6657661 (martedì, mercoledì e venerdì 08:30-13:30)',
          ],
        },
      ],
    },
    {
      id: 'protesica-invalidita-urp-giussano',
      titolo: 'Protesica, invalidità e URP',
      servizi: [
        {
          id: 'protesica-invalidita-giussano',
          nome: 'Protesica e invalidità',
          descrizione: 'Servizi di protesica (maggiore, integrativa, assorbenza), ossigenoterapia/ventiloterapia e ufficio invalidi.',
          contatti: [
            'Protesica maggiore: Tel. 0362 485277',
            'Microinfusori e freestyle: Tel. 0362 485293',
            'E-mail protesica: protesica.giussano@asst-brianza.it',
            'Protesica integrativa e assorbenza: Tel. 0362 485291 - E-mail: ausili.giussano@asst-brianza.it',
            'Ossigenoterapia e ventiloterapia: Tel. 0362 485294 - 0362 485278 - E-mail: ossigenoventilo.giussano@asst-brianza.it',
            'Ufficio invalidi: Tel. 0362 485211 - 0362 485085 - E-mail: invalidi.distrseregno@asst-brianza.it',
          ],
          accesso: 'Accesso telefonico o via e-mail.',
        },
        {
          id: 'urp-seregno-giussano',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Giussano.',
          contatti: ['Tel. 0362 984748', 'E-mail: urp.distrseregno@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaGiussano = casaDellaCOmunitaGiussano;

export const casaDellaCOmunitaLimbiate: CasaDellaComunita = {
  nome: 'Casa della Comunità di Limbiate',
  citta: 'Limbiate (MB)',
  indirizzo: 'Via Montegrappa, 19 - Limbiate (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Desio',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.5994, lng: 9.1315 },
  sezioni: [
    {
      id: 'front-office-cup-limbiate',
      titolo: 'Front-office, CUP e amministrativi',
      servizi: [
        {
          id: 'front-office-cdc-limbiate',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Richiesta informazioni, prenotazione appuntamenti per ambulatori di medicina specialistica e diagnostica di base e ambulatorio IFeC; pagamento ticket (se dovuto), scelta/revoca MMG, esenzioni per patologia, accettazione e prenotazione prelievi ematici.',
          orari: ['Sportello aperto da lunedì a venerdì: 07:30-18:00'],
          contatti: [
            'Tel. 02 9945 6250 - 02 9945 6252',
            'E-mail: front-office-cdc.limbiate@asst-brianza.it',
          ],
        },
        {
          id: 'scelta-revoca-limbiate',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'In caso di impossibilità a usare i canali online, prenotazione appuntamento allo sportello tramite servizi regionali.',
          contatti: [
            'Numero verde regionale: 800.638.638 (rete fissa)',
            'Numero da rete mobile: 02.99.95.99',
            'Prenota online: https://www.prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-limbiate',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-limbiate',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute della persona; supporto all’attivazione dei servizi per cittadini in situazione di fragilità e presa in carico nella rete sociosanitaria.',
          accesso: 'Accesso libero o su appuntamento.',
          orari: [
            'Da lunedì a venerdì: 08:30-16:00',
            'Martedì e giovedì: 08:30-18:00',
          ],
          contatti: [
            'Tel. 02 9945 6046 - 02 9945 6266',
            'E-mail: pua.limbiate@asst-brianza.it',
          ],
        },
        {
          id: 'ifec-limbiate',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Assistenza alle persone/caregiver che necessitano di interventi infermieristici tecnici ed educazione alla salute, in raccordo con MMG/PLS.',
          orari: ['Ambulatorio IFeC: da lunedì a domenica 08:00-20:00'],
          accesso: 'Con impegnativa e prenotazione presso Front-office (accesso libero da lunedì a venerdì 08:00-16:00).',
          contatti: ['Tel. 02 9945 6253', 'E-mail: amb.ifclimbiate@asst-brianza.it'],
        },
        {
          id: 'assistenza-domiciliare-limbiate',
          nome: 'Cure domiciliari',
          descrizione: 'Accompagnamento all’attivazione dei servizi domiciliari.',
          accesso: 'Attivazione attraverso il PUA.',
          contatti: [
            'Tel. 02 9945 6046 - 02 9945 6266',
            'E-mail: pua.limbiate@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'specialistica-limbiate',
      titolo: 'Specialistica, diagnostica e prelievi',
      servizi: [
        {
          id: 'punto-prelievi-limbiate',
          nome: 'Punto prelievi',
          descrizione: 'Accesso libero con impegnativa.',
          orari: ['Da lunedì a venerdì: 07:30-09:30'],
        },
        {
          id: 'medicina-specialistica-limbiate',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Prestazioni specialistiche con prenotazione CUP e valutazioni orientate al confronto MMG-specialista per presa in carico condivisa.',
          prestazioni: [
            'Otorinolaringoiatria',
            'Diabetologia',
            'Reumatologia',
            'Neuropsicologia',
          ],
          accesso: 'Con impegnativa e prenotazione presso Front-office/CUP.',
          contatti: [
            'Sportello CUP: da lunedì a venerdì 08:00-16:00',
            'Numero verde: 800.638.638',
            'Numero mobile: 02.999.599 (da lunedì a sabato 08:00-20:00)',
            'Prenota online: prenotasalute.regione.lombardia.it',
            'Farmacie del territorio aderenti',
          ],
        },
        {
          id: 'odontoiatria-disabilita-limbiate',
          nome: 'Ambulatorio di Odontoiatria “Speciale”',
          descrizione:
            'Servizio odontoiatrico ambulatoriale per pazienti con disabilità, con prestazioni della branca specialistica (igiene orale e parodontologia).',
          accesso: 'Con impegnativa e prenotazione presso Front-office/CUP.',
          orari: ['Prenotazioni presso sportello CUP: da lunedì a venerdì 08:00-16:00'],
        },
      ],
    },
    {
      id: 'prevenzione-e-continuita-limbiate',
      titolo: 'Prevenzione, vaccinazioni e continuità assistenziale',
      servizi: [
        {
          id: 'centro-vaccinale-limbiate',
          nome: 'Vaccinazioni',
          descrizione: 'Accesso tramite prenotazione sul portale vaccinale ASST Brianza.',
          orari: ['Da lunedì a venerdì 08:30-16:00'],
          contatti: [
            'Prenotazioni: https://sv.asst-brianza.it',
            'E-mail: limbiate.vaccinazioni@asst-brianza.it',
            'Vaccinazioni internazionali: desio.vaccinazioni@asst-brianza.it',
          ],
        },
        {
          id: 'continuita-assistenziale-limbiate',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Garantisce l’assistenza sanitaria di medicina generale in fascia serale/notturna, prefestiva e festiva.',
          orari: [
            'Lunedì-venerdì: 20:00-08:00',
            'Da sabato 14:00 a lunedì 08:00',
            'Festivi e prefestivi: H24',
          ],
          contatti: ['Tel. 116117'],
        },
        {
          id: 'ambulatorio-medico-diurno-limbiate',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Assistenza medica di primo livello con accesso tramite 116117 e Centrale Unica Diurna; possibilità di consulto remoto, prescrizione dematerializzata e invio alla sede ambulatoriale più vicina.',
          orari: [
            'Ambulatorio Medico Diurno: 7 giorni su 7, 08:00-20:00',
            'Numero 116117 (Centrale Unica Diurna): 7 giorni su 7, 08:00-19:00',
            'Continuità assistenziale: dalle 20:00 alle 08:00 dal lunedì al venerdì e H24 sabato, domenica, prefestivi e festivi infrasettimanali',
          ],
          contatti: ['Numero unico: 116117'],
          note: ['Gli assistiti ricevono via SMS il link per scaricare la relazione sanitaria.'],
        },
      ],
    },
    {
      id: 'protesica-invalidita-urp-limbiate',
      titolo: 'Protesica, invalidità e URP',
      servizi: [
        {
          id: 'protesica-invalidita-limbiate',
          nome: 'Protesica e invalidità',
          descrizione: 'Accesso telefonico o via e-mail ai servizi dedicati di protesica, ausili e invalidità.',
          orari: ['Protesica maggiore/minore: martedì e giovedì 09:00-12:00'],
          contatti: [
            'Protesica maggiore: Tel. 0362 385940 - E-mail: protesica.desio@asst-brianza.it',
            'Protesica minore: Tel. 0362 385331 - E-mail: ausili.desio@asst-brianza.it',
            'Ausili per assorbenza: Tel. 0362 385929 - E-mail: assorbenza.desio@asst-brianza.it',
            'Ufficio invalidi: Tel. 0362 385928 - E-mail: invalidi.distrdesio@asst-brianza.it',
          ],
        },
        {
          id: 'urp-desio-limbiate',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Limbiate.',
          contatti: ['Tel. 039 2335319/20', 'E-mail: urp.distrdesio@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaLimbiate = casaDellaCOmunitaLimbiate;

export const casaDellaCOmunitaLentateSulSeveso: CasaDellaComunita = {
  nome: 'Casa della Comunità di Lentate sul Seveso',
  citta: 'Lentate sul Seveso (MB)',
  indirizzo: 'Via Garibaldi, 37 - Lentate sul Seveso (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Seregno',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6826, lng: 9.1197 },
  sezioni: [
    {
      id: 'presentazione-lentate',
      titolo: 'La Casa di Comunità',
      servizi: [
        {
          id: 'ruolo-cdc-lentate',
          nome: 'Punto unico di riferimento per la salute',
          descrizione:
            'La Casa di Comunità di Lentate sul Seveso è il punto di accesso ai servizi sanitari e sociosanitari del territorio.',
          prestazioni: [
            'Percorso di cure personalizzato',
            'Accesso integrato all’assistenza sanitaria, sociosanitaria e socioassistenziale',
            'Presa in carico delle cronicità',
            'Valutazione a 360° del bisogno di salute grazie a un team di professionisti medici e sanitari',
          ],
          contatti: [
            'URP Distretto Seregno: Tel. 0362 984748',
            'E-mail: urp.distrseregno@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'accoglienza-cup-lentate',
      titolo: 'Accoglienza, CUP e pratiche amministrative',
      servizi: [
        {
          id: 'accoglienza-cup-lentate-main',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Sportello amministrativo per accoglienza, informazioni, accettazione, prenotazioni; scelta/revoca, esenzioni per patologia/reddito/invalidità, richieste tessere sanitarie, rilascio credenziali PIN/PUK e OTP, scelta medico di base per cittadini italiani.',
          accesso: 'Accesso libero.',
          orari: ['Da lunedì a venerdì: 08:00-18:00'],
          contatti: [
            'Tel. 0362 984844 (dalle 13:30 alle 15:30)',
            'E-mail: front-office-cdc.lentate@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-lentate',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-lentate',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute; supporto nell’attivazione dei servizi per cittadini in situazione di fragilità e presa in carico nella rete sociosanitaria.',
          accesso: 'Accesso libero.',
          orari: ['Da lunedì a sabato: 08:30-13:00', 'Da lunedì a sabato: 13:30-15:30'],
          contatti: ['Tel. 0362 984845', 'E-mail: pua.lentate@asst-brianza.it'],
          prestazioni: [
            'Raccolta richieste attivazione ADI',
            'Supporto su protesica e farmacia territoriale',
          ],
        },
        {
          id: 'cure-domiciliari-lentate',
          nome: 'Cure domiciliari',
          descrizione:
            'Servizio attivabile a cura di PUA/IFeC per garantire gratuitamente, alle persone fragili/non autosufficienti, prestazioni sociosanitarie integrate a domicilio erogate da professionisti sanitari.',
          prestazioni: [
            'Prelievi ematici',
            'Medicazioni',
            'Sostituzione catetere vescicale',
            'Gestione accessi vascolari e stomie',
            'Trattamenti riabilitativi',
          ],
          contatti: ['E-mail: pua.lentate@asst-brianza.it'],
        },
        {
          id: 'ifec-lentate',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Assistenza alle persone/caregiver che necessitano di interventi infermieristici tecnici ed educazione alla salute, in raccordo con MMG/PLS.',
          accesso: 'Accesso con impegnativa MMG e prenotazione allo sportello Accoglienza-CUP.',
          orari: ['Ambulatorio attivo da lunedì a domenica: 09:30-18:00'],
          contatti: ['Tel. 0362 984847', 'E-mail: amb.ifclentate@asst-brianza.it'],
        },
      ],
    },
    {
      id: 'specialistica-prelievi-lentate',
      titolo: 'Specialistica, diagnostica e prelievi',
      servizi: [
        {
          id: 'punto-prelievi-lentate',
          nome: 'Punto prelievi',
          descrizione: 'Accesso libero con impegnativa MMG.',
          orari: ['Da lunedì a venerdì: 07:30-09:30'],
        },
        {
          id: 'medicina-specialistica-lentate',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista, per una presa in carico condivisa.',
          prestazioni: ['Diabetologia', 'Fisiatria', 'Epatologia'],
          accesso: 'Accesso con impegnativa MMG e prenotazione allo sportello Accoglienza-CUP.',
          contatti: [
            'Contact Center Regionale: lunedì-sabato 08:00-20:00',
            'Numero verde rete fissa: 800.638.638',
            'Numero da rete mobile: 02.999.599',
            'Prenota online: prenotasalute.regione.lombardia.it',
            'Farmacie del territorio aderenti',
          ],
        },
      ],
    },
    {
      id: 'ambulatorio-diurno-lentate',
      titolo: 'Continuità Assistenziale',
      servizi: [
        {
          id: 'amd-ca-lentate',
          nome: 'Continuità Assistenziale',
          descrizione:
            'L’Ambulatorio Medico Diurno garantisce assistenza medica di primo livello senza sostituire MMG/PLS. L’accesso avviene contattando il Numero Europeo Armonizzato 116117 e la Centrale Unica Diurna gestisce consulto remoto, eventuale prescrizione e invio all’ambulatorio più vicino.',
          orari: [
            'Ambulatorio Medico Diurno: 7 giorni su 7, 08:00-20:00',
            'Numero 116117 (Centrale Unica Diurna): 7 giorni su 7, 08:00-19:00',
            'Continuità assistenziale: dalle 20:00 alle 08:00 dal lunedì al venerdì e H24 sabato, domenica, prefestivi e festivi infrasettimanali',
          ],
          contatti: ['Numero unico: 116117'],
          note: [
            'Tutti gli assistiti ricevono via SMS un link per scaricare la relazione sanitaria.',
            'Per assistiti temporaneamente senza MMG: Tel. 039 6657199 da lunedì a venerdì 08:30-16:00 (su appuntamento).',
          ],
        },
      ],
    },
    {
      id: 'consultorio-psicologia-lentate',
      titolo: 'Consultorio familiare e psicologia',
      servizi: [
        {
          id: 'consultorio-familiare-lentate',
          nome: 'Consultorio familiare',
          descrizione:
            'Interventi di prevenzione e assistenza sanitaria, psicologica e sociale a tutela della salute dell’individuo, della coppia e della famiglia nelle diverse fasi della vita.',
          prestazioni: [
            'Consultorio Lentate (Tel. 0362 984829) - MAR 09:00-12:30 / 14:00-15:30; VEN 09:00-12:30; E-mail: consultorio.lentate@asst-brianza.it',
            'Consultorio Seveso (Tel. 0362 984693) - LUN 09:00-12:30; MER-GIO 14:00-15:30; E-mail: consultorio.seveso@asst-brianza.it',
            'Consultorio Seregno (Tel. 0362 984761) - MAR-VEN 09:00-12:30; LUN-MER-GIO 14:00-16:00; MAR 14:00-15:30; E-mail: consultorio.seregno@asst-brianza.it',
          ],
        },
        {
          id: 'psicologia-cure-primarie-lentate',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio dedicato ai bisogni psicoemotivi (difficoltà emotive, condizioni ansioso-depressive, difficoltà psicologiche legate agli eventi di vita) e alla promozione del benessere e dell’agio psicologico.',
          accesso: 'Accesso libero e gratuito, senza impegnativa del medico, scrivendo una mail al servizio.',
          orari: ['Ambulatorio aperto il giovedì: 08:30-16:00'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico mirato al potenziamento delle risorse personali',
            'Percorsi di terapia di gruppo',
          ],
          note: [
            'Nella mail indicare: nome, cognome, data di nascita, comune di residenza, medico/pediatra di riferimento, motivo richiesta, contatti mail e telefonico.',
          ],
        },
      ],
    },
    {
      id: 'urp-lentate',
      titolo: 'Ufficio Relazioni con il Pubblico',
      servizi: [
        {
          id: 'urp-seregno-lentate',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Lentate sul Seveso.',
          contatti: ['Tel. 0362 984748', 'E-mail: urp.distrseregno@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaLentateSulSeveso = casaDellaCOmunitaLentateSulSeveso;

export const casaDellaCOmunitaLissone: CasaDellaComunita = {
  nome: 'Casa della Comunità di Lissone',
  citta: 'Lissone (MB)',
  indirizzo: 'Via Bernasconi, 16 - Lissone (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Carate Brianza',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6150, lng: 9.2430 },
  sezioni: [
    {
      id: 'presentazione-lissone',
      titolo: 'La Casa di Comunità',
      servizi: [
        {
          id: 'ruolo-cdc-lissone',
          nome: 'Punto unico di riferimento per la salute',
          descrizione:
            'La Casa di Comunità di Lissone è il punto di accesso ai servizi sanitari e sociosanitari del territorio.',
          prestazioni: [
            'Percorso di cure personalizzato',
            'Accesso integrato all’assistenza sanitaria, sociosanitaria e socioassistenziale',
            'Presa in carico delle cronicità',
            'Valutazione a 360° del bisogno di salute grazie a un team di professionisti medici e sanitari',
          ],
          contatti: [
            'URP Carate Brianza: Tel. 0362 984799',
            'E-mail: urp.distrcarate@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'front-office-cup-lissone',
      titolo: 'Front-office, CUP e pratiche amministrative',
      servizi: [
        {
          id: 'front-office-cdc-lissone',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Sportello amministrativo per informazioni, prenotazioni, accettazione; pagamento ticket (se dovuto) e supporto alle pratiche amministrative.',
          orari: ['Sportello aperto da lunedì a venerdì: 08:00-20:00'],
          contatti: ['Tel. 039 6654256', 'E-mail: front-office-cdc.lissone@asst-brianza.it'],
          prestazioni: [
            'Richiesta informazioni',
            'Prenotazione appuntamenti per ambulatori di medicina specialistica e diagnostica di base e ambulatorio IFeC',
            'Pagamento ticket per prestazioni afferenti alla CdC',
            'Scelta e revoca Medico Medicina Generale, esenzioni per patologia/reddito/invalidità e scelta del medico di base per persone fragili',
          ],
        },
        {
          id: 'scelta-revoca-lissone',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Sportello Istanze Online Cittadino e canali regionali per fissare appuntamento allo sportello in caso di impossibilità all’uso dei servizi online.',
          accesso: 'Su appuntamento.',
          contatti: [
            'SIOC: https://sioc.asst-brianza.it',
            'Numero verde regionale: 800.638.638',
            'Numero da rete mobile: 02.99.95.99',
            'Prenota online: https://prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
          prestazioni: [
            'Iscrizioni al Servizio Sanitario Regionale',
            'Esenzioni per patologia, reddito, status e invalidità',
            'Scelta e revoca Medico Medicina Generale MMG/PLS',
            'Codici PIN/PUK',
            'Codici OTP',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-lissone',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-lissone',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Servizio di accoglienza socio-sanitaria integrata volto a informare e orientare gli utenti nella fruizione dei servizi socio-sanitari e socio-assistenziali; raccolta richieste per attivazione ADI, protesica, farmacia territoriale e valutazione bisogni di salute in condizioni di fragilità e cronicità.',
          orari: ['Da lunedì a venerdì: 09:00-16:00'],
          contatti: [
            'Tel. Infermiere di Famiglia: 039 6654350',
            'Tel. Assistente Sociale: 039 6654377',
            'E-mail: pua.lissone@asst-brianza.it',
          ],
        },
        {
          id: 'ifec-lissone',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Presenza infermieristica territoriale e ambulatorio dedicato all’assistenza di pazienti e caregiver con interventi tecnico-infermieristici e di educazione all’auto-cura, in accordo con MMG o PLS.',
          orari: [
            'Presenza infermiere di famiglia e comunità: 08:00-20:00',
            'Ambulatorio IFeC: da lunedì a venerdì 08:30-19:00',
          ],
          accesso: 'Accesso su impegnativa MMG e prenotazione c/o Front-office CdC.',
          contatti: ['Tel. 039 6654630', 'E-mail: amb.ifclissone@asst-brianza.it'],
        },
        {
          id: 'cure-domiciliari-lissone',
          nome: 'Cure domiciliari',
          descrizione:
            'Prestazioni sociosanitarie integrate a domicilio per persone in condizione di fragilità/non autosufficienza, attivate su prescrizione e declinate nel Piano Assistenziale Individuale (PAI) con erogazione da enti accreditati.',
          orari: ['Per informazioni: da lunedì a venerdì 08:30-16:00'],
          contatti: ['Tel. 039 6654378 - 039 6654350', 'E-mail: pua.lissone@asst-brianza.it'],
          prestazioni: [
            'Prelievi ematici',
            'Medicazioni',
            'Sostituzione catetere vescicale',
            'Gestione accessi vascolari e stomie',
            'Trattamenti riabilitativi',
          ],
        },
        {
          id: 'cot-lissone',
          nome: 'Centrale Operativa Territoriale (COT)',
          descrizione:
            'Funzione di supporto in back office al coordinamento della presa in carico di assistiti fragili e cronici, con gestione delle segnalazioni da diversi setting assistenziali e facilitazione della transizione ospedale-territorio/domicilio/strutture intermedie.',
        },
      ],
    },
    {
      id: 'specialistica-salute-mentale-lissone',
      titolo: 'Specialistica, prelievi e salute mentale',
      servizi: [
        {
          id: 'medicina-specialistica-lissone',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista.',
          accesso: 'Con impegnativa del medico curante e prenotazione presso Front-office CdC o CUP aziendali.',
          prestazioni: [
            'Cardiologia',
            'Diabetologia',
            'Fisiatria',
            'Geriatria',
            'Pneumologia',
            'Reumatologia',
            'Medicina interna',
            'Neurologia',
            'Neuropsicologia',
            'Angiologia',
            'Dermatologia',
          ],
        },
        {
          id: 'punto-prelievi-lissone',
          nome: 'Punto prelievi',
          descrizione:
            'Accesso diretto senza prenotazione con impegnativa MMG/PLS/Medico Specialista.',
          orari: ['Dal lunedì al venerdì: 07:30-10:30'],
          contatti: ['Tel. Punto prelievi: 039 6654243'],
        },
        {
          id: 'neuropsichiatria-infantile-lissone',
          nome: 'Neuropsichiatria infantile',
          descrizione:
            'Diagnosi e cura di patologie neurologiche, psichiatriche e neuropsicologiche dell’infanzia e dell’adolescenza, inclusi disordini di sviluppo neuropsicomotorio, linguistico, della comunicazione, cognitivo e relazionale.',
          orari: [
            'Prime visite: martedì 14:00-16:00 (anche telefoniche)',
            'Prime visite: mercoledì 09:00-11:00 (anche telefoniche)',
          ],
          contatti: [
            'Tel. 039 6654756 - 039 6654014',
            'E-mail: uonpia.lissone@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'ambulatorio-diurno-continuita-lissone',
      titolo: 'Continuità Assistenziale',
      servizi: [
        {
          id: 'ambulatorio-medico-diurno-lissone',
          nome: 'Ambulatorio Medico Diurno',
          descrizione:
            'Assistenza medica di primo livello senza sostituire MMG/PLS, con accesso tramite Numero Europeo Armonizzato 116117 e Centrale Unica Diurna.',
          orari: [
            'Ambulatorio Medico Diurno: 7 giorni su 7, 08:00-20:00',
            'Numero 116117: 7 giorni su 7, 08:00-20:00',
          ],
          contatti: ['Numero unico: 116117'],
          note: [
            'La Centrale Unica gestisce consulto remoto (anche in videochiamata), eventuale prescrizione dematerializzata e invio all’ambulatorio più vicino.',
            'Gli assistiti ricevono via SMS un link per scaricare la relazione sanitaria.',
          ],
        },
        {
          id: 'continuita-assistenziale-lissone',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Servizio di assistenza sanitaria di medicina generale e pediatria nelle ore notturne, prefestive e festive, attivato dalla centrale operativa unica 116117.',
          orari: ['Lunedì-venerdì 19:00-08:00', 'Sabato, domenica e festivi: H24'],
          contatti: ['Tel. 116117'],
          note: [
            'Contattare il 116117 prima di presentarsi in ambulatorio di continuità assistenziale.',
          ],
        },
      ],
    },
    {
      id: 'benessere-sportelli-lissone',
      titolo: 'Benessere psicologico e sportelli',
      servizi: [
        {
          id: 'psicologia-cure-primarie-lissone',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio dedicato ai bisogni psico emotivi della persona e alla promozione del benessere psicologico, con particolare attenzione a bambini, adolescenti e genitori.',
          accesso: 'Accesso libero e gratuito senza impegnativa, scrivendo una mail al servizio.',
          orari: ['Ambulatorio aperto da lunedì a venerdì: 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico mirato al potenziamento delle risorse personali',
            'Percorsi di terapia di gruppo',
          ],
          note: [
            'Nella mail indicare: nome, cognome, data di nascita, comune di residenza, medico/pediatra di riferimento, motivo richiesta, contatti mail e telefonico.',
          ],
        },
        {
          id: 'sportello-dipendenze-lissone',
          nome: 'Sportello ascolto dipendenze patologiche',
          descrizione:
            'Sportello ad accesso libero di ascolto, conoscenza e consulenza rivolto a soggetti con problematiche legate all’uso di sostanze, alcol e comportamenti additivi, compreso il gioco d’azzardo.',
          orari: ['Giovedì 14:00-18:00'],
          contatti: [
            'Tel. 039 2334927 - 039 6654399',
            'E-mail: michela.polletta@asst-brianza.it',
          ],
        },
        {
          id: 'sportello-alzheimer-lissone',
          nome: 'Sportello Alzheimer',
          descrizione:
            'Collaborazione con l’Associazione di Volontariato “Felicemente segui l’Onda” di Carate Brianza, con iniziative a supporto di caregiver e persone con Alzheimer; disponibili momenti di incontro previo appuntamento.',
          contatti: [
            'Riferimento: pua.lissone@asst-brianza.it',
            'Tel. 039 6654378 - 039 6654350',
          ],
        },
      ],
    },
    {
      id: 'segreteria-urp-lissone',
      titolo: 'Segreteria distrettuale e URP',
      servizi: [
        {
          id: 'urp-carate-lissone',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP del Distretto Carate Brianza.',
          orari: ['Da lunedì a venerdì: 09:00-12:30'],
          contatti: ['Tel. 0362 984799 - 8', 'E-mail: urp.distrcarate@asst-brianza.it'],
        },
        {
          id: 'mobilita-internazionale-lissone',
          nome: 'Mobilità internazionale e iscrizioni volontarie SSN',
          descrizione:
            'Servizi della segreteria distrettuale presso Via Mascherpa 14 (Carate Brianza) su appuntamento.',
          orari: ['Da lunedì a venerdì: 09:00-12:30'],
          contatti: ['Tel. 0362 984799', 'E-mail: estero.carate@asst-brianza.it'],
          prestazioni: [
            'Iscrizioni volontarie al SSN',
            'Dichiarazione di volontà alla donazione di organi e tessuti',
          ],
        },
        {
          id: 'interdizione-maternita-lissone',
          nome: 'Interdizione anticipata dal lavoro (maternità anticipata)',
          descrizione: 'Servizio amministrativo distrettuale dedicato.',
          contatti: ['Tel. 0362 984798'],
        },
        {
          id: 'rimborso-dialisi-lissone',
          nome: 'Domanda rimborso/contributo spese trattamenti dialitici',
          descrizione: 'Servizio su appuntamento della segreteria distrettuale.',
          orari: ['Da lunedì a venerdì: 09:00-12:30'],
          contatti: ['Tel. 0362 984798 - 9', 'E-mail: segreteria.distrcarate@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaLissone = casaDellaCOmunitaLissone;

export const casaDellaCOmunitaMonza: CasaDellaComunita = {
  nome: 'Casa della Comunità di Monza (Via Solferino)',
  citta: 'Monza (MB)',
  indirizzo: 'Via Solferino, 16 (Ospedale Vecchio) - Monza (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Monza',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.5855, lng: 9.2713 },
  sezioni: [
    {
      id: 'front-office-cup-monza',
      titolo: 'Front-office, CUP e pratiche amministrative',
      servizi: [
        {
          id: 'front-office-cdc-monza',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Accesso libero per accoglienza e informazione sull’accesso ai servizi; prenotazione appuntamenti per ambulatori specialistici e infermieristici; pagamento ticket in modalità elettronica; pratiche amministrative sanitarie.',
          orari: ['Da lunedì a venerdì: 08:00-20:00'],
          contatti: ['Tel. 039 6657157', 'E-mail: front-office-cdc.monza@asst-brianza.it'],
          prestazioni: [
            'Rinnovo tessere sanitarie per utenti stranieri',
            'Domiciliazione sanitaria',
            'Iscrizioni al SSN',
            'Esenzioni per patologia, reddito, status e invalidità',
            'Scelta/revoca MMG e PLS',
            'Codici PIN/PUK e OTP (Fascicolo Sanitario Elettronico)',
            'Consenso al Fascicolo Sanitario Elettronico e alle notifiche in ambito sanitario',
          ],
          note: [
            'Pratiche eseguibili anche tramite SIOC: https://sioc.asst-brianza.it/SIOC/',
            'Su appuntamento via call center regionale: 800638638 (rete fissa) / 02999599 (rete mobile), o portale prenotasalute.regione.lombardia.it (voce “prenota senza ricetta”).',
          ],
        },
        {
          id: 'scelta-revoca-cdc-monza',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Accesso libero per accoglienza e informazione sull’accesso ai servizi; prenotazione appuntamenti per ambulatori specialistici e infermieristici; pagamento ticket in modalità elettronica; pratiche amministrative sanitarie.',
          orari: ['Da lunedì a venerdì: 08:00-20:00'],
          contatti: ['Tel. 039 6657157', 'E-mail: front-office-cdc.monza@asst-brianza.it'],
          prestazioni: [
            'Rinnovo tessere sanitarie per utenti stranieri',
            'Domiciliazione sanitaria',
            'Iscrizioni al SSN',
            'Esenzioni per patologia, reddito, status e invalidità',
            'Scelta/revoca MMG e PLS',
            'Codici PIN/PUK e OTP (Fascicolo Sanitario Elettronico)',
            'Consenso al Fascicolo Sanitario Elettronico e alle notifiche in ambito sanitario',
          ],
          note: [
            'Pratiche eseguibili anche tramite SIOC: https://sioc.asst-brianza.it/SIOC/',
            'Su appuntamento via call center regionale: 800638638 (rete fissa) / 02999599 (rete mobile), o portale prenotasalute.regione.lombardia.it (voce “prenota senza ricetta”).',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-monza',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-monza',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute; supporto nell’attivazione dei servizi per cittadini in situazione di fragilità e presa in carico dalla rete sociosanitaria.',
          accesso: 'Accesso libero da lunedì a venerdì.',
          orari: ['Da lunedì a venerdì: 08:00-15:30'],
          contatti: ['Tel. 039 6657156 / 039 6657154', 'E-mail: pua.monza@asst-brianza.it'],
          prestazioni: [
            'Raccolta richieste attivazione ADI',
            'Protesica',
            'Farmacia territoriale',
          ],
        },
        {
          id: 'ifec-monza',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Al domicilio o presso ambulatorio, svolge attività di individuazione, presa in carico, monitoraggio e follow-up di persone a rischio, fragili e/o con patologie croniche; ambulatorio di assistenza tecnico-infermieristica e di educazione all’auto-cura.',
          orari: ['Tutti i giorni: 08:00-20:00'],
          contatti: ['Tel. 039 6657156', 'E-mail: ifec.monza@asst-brianza.it'],
          accesso:
            'Accesso tramite valutazione domanda presso PUA; oppure con impegnativa MMG (con codice e dicitura “Casa di Comunità”) e prenotazione presso Front-office CdC.',
        },
        {
          id: 'cure-domiciliari-monza',
          nome: 'Cure domiciliari',
          descrizione:
            'Accompagnamento all’attivazione dei servizi di assistenza domiciliare tramite PUA.',
          accesso: 'Attivazione attraverso il Punto Unico di Accesso (PUA).',
          orari: ['Da lunedì a venerdì: 08:00-15:30'],
          contatti: ['Tel. 039 6657156 / 039 6657154', 'E-mail: pua.monza@asst-brianza.it'],
        },
      ],
    },
    {
      id: 'specialistica-prelievi-monza',
      titolo: 'Specialistica, diagnostica e prelievi',
      servizi: [
        {
          id: 'punto-prelievi-monza',
          nome: 'Punto prelievi',
          descrizione: 'Servizio prelievi ad accesso diretto con impegnativa MMG/PLS/Medico Specialista.',
          orari: ['Dal lunedì al venerdì: 07:30-09:30'],
          accesso: 'Non occorre prenotazione.',
        },
        {
          id: 'medicina-specialistica-monza',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista, per presa in carico condivisa.',
          prestazioni: [
            'Cardiologia',
            'Diabetologia',
            'Epatologia',
            'Geriatria',
            'Neurologia',
            'Pneumologia',
            'Reumatologia',
            'Attività di ecografia',
          ],
          accesso: 'Con impegnativa del medico curante e prenotazione presso Front-office o CUP.',
        },
      ],
    },
    {
      id: 'sportelli-monza',
      titolo: 'Sportelli dedicati',
      servizi: [
        {
          id: 'sportello-gap-monza',
          nome: 'Sportello Gioco d’Azzardo patologico (GAP)',
          descrizione:
            'Sportello di ascolto, conoscenza e consulenza rivolto a persone con problematiche connesse al gioco d’azzardo, all’uso di sostanze, alcol e altri comportamenti additivi, e ai familiari.',
          accesso: 'Accesso libero.',
          orari: ['Venerdì 09:00-13:00'],
          contatti: ['Tel. 039 6657156 / 039 6657154', 'E-mail: pua.monza@asst-brianza.it'],
        },
      ],
    },
    {
      id: 'cure-primarie-monza',
      titolo: 'Cure primarie',
      servizi: [
        {
          id: 'amt-monza',
          nome: 'Ambulatorio Medico Temporaneo (AMT)',
          descrizione:
            'Ambulatorio dedicato ai cittadini cui non è stato possibile assegnare un nuovo medico a seguito di dimissioni del precedente. Consente prenotazione visite, consulenza medica, ricettazione farmaci in uso e certificazioni.',
          orari: ['Numero attivo dal lunedì al venerdì: 08:30-16:00', 'Attivo secondo programmazione aziendale'],
          contatti: ['Tel. 039 6657199', 'Informazioni orari: https://www.asst-brianza.it/web/index.php/schede/scheda/57'],
          note: ['Gli assistiti bisognosi di consulenza medica vengono contattati direttamente dall’équipe AMT di afferenza.'],
        },
        {
          id: 'amd-ca-monza',
          nome: 'Continuità Assistenziale',
          descrizione:
            'L’Ambulatorio Medico Diurno garantisce assistenza medica di primo livello senza sostituire MMG/PLS. Accesso tramite 116117 e Centrale Unica Diurna con consulto remoto, eventuale prescrizione dematerializzata e invio all’ambulatorio più vicino.',
          orari: [
            'Ambulatorio Medico Diurno: tutti i giorni 08:00-20:00',
            'Numero 116117 (tasto 2): 7 giorni su 7 08:00-19:00',
            'Continuità Assistenziale: dalle 20:00 alle 08:00 dal lunedì al venerdì e H24 sabato, domenica, prefestivi e festivi infrasettimanali (accesso 116117, tasto 1)',
          ],
          contatti: ['Numero unico: 116117'],
          note: ['Gli assistiti ricevono via SMS un link per scaricare la relazione sanitaria.'],
        },
      ],
    },
    {
      id: 'urp-monza',
      titolo: 'Ufficio Relazioni con il Pubblico',
      servizi: [
        {
          id: 'urp-distretto-monza',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Monza.',
          contatti: ['Tel. 039 6657836', 'E-mail: urp.distrmonza@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaMonza = casaDellaCOmunitaMonza;

export const casaDellaCOmunitaSeregno: CasaDellaComunita = {
  nome: 'Casa della Comunità di Seregno',
  citta: 'Seregno (MB)',
  indirizzo: 'Via Giuseppe Verdi, 2 - Seregno (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Seregno',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6633, lng: 9.1988 },
  sezioni: [
    {
      id: 'presentazione-seregno',
      titolo: 'La Casa di Comunità',
      servizi: [
        {
          id: 'ruolo-cdc-seregno',
          nome: 'Punto unico di riferimento per la salute',
          descrizione:
            'La Casa di Comunità di Seregno è il punto di accesso ai servizi sanitari e sociosanitari del territorio.',
          prestazioni: [
            'Percorso di cure personalizzato',
            'Accesso integrato all’assistenza sanitaria, sociosanitaria e socioassistenziale',
            'Presa in carico delle cronicità',
            'Valutazione a 360° del bisogno di salute grazie a un team di professionisti medici e sanitari',
          ],
          contatti: [
            'URP Distretto Seregno: Tel. 0362 984748',
            'E-mail: urp.distrseregno@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'accoglienza-cup-seregno',
      titolo: 'Accoglienza, CUP e pratiche amministrative',
      servizi: [
        {
          id: 'accoglienza-cup-seregno-main',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Sportello amministrativo per accoglienza, informazioni, accettazione e prenotazioni.',
          accesso: 'Accesso libero.',
          orari: ['Da lunedì a venerdì: 08:00-16:00'],
          contatti: [
            'Tel. 0362 385433 (dalle 13:30 alle 15:30)',
            'E-mail: front-office-cdc.seregno@asst-brianza.it',
          ],
          prestazioni: [
            'Scelta/revoca: esenzioni per patologia, reddito, invalidità',
            'Richieste tessere sanitarie',
            'Rilascio credenziali PIN/PUK e OTP',
            'Scelta del medico di base per cittadini italiani',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-seregno',
      titolo: 'Presa in carico territoriale e domiciliarità',
      servizi: [
        {
          id: 'pua-seregno',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accoglienza, orientamento e prima valutazione del bisogno di salute della persona; supporto nell’attivazione dei servizi per cittadini in situazione di fragilità e presa in carico dalla rete sociosanitaria. Raccoglie richieste attivazione ADI, protesica e farmacia territoriale.',
          accesso: 'Accesso libero.',
          orari: ['Lunedì-venerdì: 08:30-13:00 / 13:30-15:30'],
          contatti: ['Tel. 0362 385420', 'E-mail: pua.seregno@asst-brianza.it'],
        },
        {
          id: 'ifec-seregno',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Assistenza alle persone/caregiver che necessitano di interventi infermieristici tecnici ed educazione alla salute, in raccordo con MMG/PLS.',
          accesso: 'Accesso con impegnativa MMG e prenotazione allo sportello Accoglienza-CUP.',
          orari: ['Ambulatorio attivo: lunedì-venerdì 08:30-13:00'],
          contatti: ['Tel. 0362 385430', 'E-mail: pua.seregno@asst-brianza.it'],
        },
        {
          id: 'assistenza-domiciliare-seregno',
          nome: 'Cure domiciliari',
          descrizione:
            'Accompagnamento all’attivazione dei servizi domiciliari tramite PUA.',
          accesso: 'Attivazione attraverso il Punto Unico di Accesso (PUA).',
          note: ['Vedi servizio “Punto Unico di Accesso - PUA”.'],
        },
      ],
    },
    {
      id: 'specialistica-prelievi-seregno',
      titolo: 'Specialistica, diagnostica e prelievi',
      servizi: [
        {
          id: 'punto-prelievi-seregno',
          nome: 'Punto prelievi',
          descrizione: 'Accesso libero con impegnativa MMG.',
          orari: ['Lunedì-venerdì: 07:30-10:00'],
          contatti: ['Tel. 0362 385431 (dalle 07:30 alle 10:00)'],
        },
        {
          id: 'medicina-specialistica-seregno',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione: 'Valutazione specialistica su richiesta MMG.',
          accesso: 'Accesso con impegnativa MMG e prenotazione allo sportello Accoglienza-CUP.',
          prestazioni: ['Diabetologia', 'Ortopedia', 'Fisiatria'],
          contatti: [
            'Contact Center Regionale (lunedì-sabato 08:00-20:00)',
            'Numero verde rete fissa: 800.638.638',
            'Numero da rete mobile: 02.999.599',
            'Prenota online: prenotasalute.regione.lombardia.it',
            'Farmacie del territorio aderenti',
          ],
        },
      ],
    },
    {
      id: 'altri-servizi-seregno',
      titolo: 'Altri servizi',
      servizi: [
        {
          id: 'tabagismo-seregno',
          nome: 'Ambulatorio per il tabagismo',
          descrizione: 'Accesso senza impegnativa (con ticket).',
          orari: ['Giovedì 14:00-16:30'],
          contatti: ['E-mail: noa.seregno@asst-brianza.it', 'Tel. 0362 984813'],
        },
        {
          id: 'continuita-assistenziale-seregno',
          nome: 'Continuità Assistenziale',
          descrizione: 'Garantisce l’assistenza sanitaria non urgente.',
          contatti: ['NUE 116117 (numero gratuito)'],
          orari: ['Lunedì-venerdì 20:00-08:00', 'Festivi e prefestivi H24'],
        },
        {
          id: 'urp-seregno-main',
          nome: 'Ufficio Relazioni con il Pubblico (URP)',
          descrizione: 'Punto di riferimento URP per la Casa della Comunità di Seregno.',
          contatti: ['Tel. 0362 984748', 'E-mail: urp.distrseregno@asst-brianza.it'],
        },
      ],
    },
  ],
};

export const casaDellaComunitaSeregno = casaDellaCOmunitaSeregno;

export const casaDellaCOmunitaMacherio: CasaDellaComunita = {
  nome: 'Casa della Comunità di Macherio',
  citta: 'Macherio (MB)',
  indirizzo: 'Via Italia 13 - Macherio (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Carate Brianza',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.6370, lng: 9.2643 },
  sezioni: [
    {
      id: 'presentazione-macherio',
      titolo: 'La Casa di Comunità',
      servizi: [
        {
          id: 'ruolo-cdc-macherio',
          nome: 'Punto unico di riferimento per la salute',
          descrizione:
            'La Casa della Comunità di Macherio è il punto di accesso ai servizi sanitari e sociosanitari del territorio, gestita da ASST Brianza.',
          prestazioni: [
            'Percorso di cure personalizzato',
            'Accesso integrato all’assistenza sanitaria, sociosanitaria e socioassistenziale',
            'Presa in carico delle cronicità',
            'Valutazione a 360° del bisogno di salute grazie a un team di professionisti medici e sanitari',
          ],
          contatti: [
            'URP - Carate Brianza',
            'Tel. 0362 984799',
            'E-mail: urp.distrcarate@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'segreteria-distretto-macherio',
      titolo: 'Segreteria distrettuale e URP',
      servizi: [
        {
          id: 'segreteria-distretto-main-macherio',
          nome: 'Segreteria del distretto - via Mascherpa 14, Carate Brianza',
          descrizione:
            'Servizi amministrativi distrettuali su appuntamento.',
          orari: ['URP: lunedì-venerdì 09:00-12:30'],
          contatti: [
            'Tel. 0362 984799 - 8',
            'E-mail: urp.distrcarate@asst-brianza.it',
            'Tel. 0362 984799 (iscrizioni volontarie SSN)',
            'E-mail: estero.carate@asst-brianza.it',
            'Tel. 0362 984798 (maternità anticipata)',
            'Tel. 0362 984798 - 9 (trattamenti dialitici)',
            'E-mail: segreteria.distrcarate@asst-brianza.it',
          ],
          prestazioni: [
            'Ufficio Relazioni con il Pubblico (URP)',
            'Mobilità internazionale',
            'Iscrizioni volontarie al SSN',
            'Dichiarazione di volontà alla donazione di organi e tessuti',
            'Interdizione anticipata dal lavoro (maternità anticipata)',
            'Domanda di rimborso/contributo spese per l’effettuazione di trattamenti dialitici',
          ],
        },
      ],
    },
    {
      id: 'prelievi-pua-macherio',
      titolo: 'Punto prelievi e PUA',
      servizi: [
        {
          id: 'punto-prelievi-macherio',
          nome: 'Punto prelievi',
          descrizione:
            'Accesso diretto senza prenotazione con impegnativa MMG/PLS/Medico Specialista.',
          orari: ['Da lunedì a venerdì: 07:30-09:30'],
          contatti: ['Tel. Punto Prelievi: 039 6654574'],
        },
        {
          id: 'pua-macherio',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Servizio di accoglienza socio-sanitaria integrata per informare e orientare gli utenti nella fruizione dei servizi socio-sanitari e socio-assistenziali; raccoglie richieste per attivazione ADI, protesica, farmacia territoriale e attiva i servizi per persone in situazione di fragilità e cronicità.',
          orari: ['Sportello: lunedì-venerdì 09:00-19:00'],
          contatti: [
            'Tel. 039 6654573',
            'Tel. Assistente sociale: 039 6654578',
            'E-mail: pua.macherio@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'front-office-cvi-alzheimer-macherio',
      titolo: 'Front Office, CVI e supporto Alzheimer',
      servizi: [
        {
          id: 'front-office-cup-macherio',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Sportello per informazioni, prenotazioni e pratiche amministrative della CdC.',
          orari: ['Da lunedì a venerdì: 08:00-16:00'],
          contatti: [
            'Tel. 039 6654002 - 039 6654571',
            'E-mail: front-office-cdc.macherio@asst-brianza.it',
          ],
          prestazioni: [
            'Richiesta informazioni',
            'Prenotazione appuntamenti per ambulatori di medicina specialistica, diagnostica di base e ambulatorio IFeC',
            'Pagamento ticket (se dovuto) per prestazioni afferenti alla CdC',
            'Scelta e revoca Medico Medicina Generale, esenzioni per patologia/reddito/invalidità, scelta del medico di base per persone fragili',
          ],
        },
        {
          id: 'cvi-macherio',
          nome: 'Sportello Centro Vita Indipendente (CVI)',
          descrizione:
            'Sportello in collaborazione con l’Ambito di Carate Brianza, rivolto a persone con disabilità per costruire il progetto di vita in base a bisogni e desideri.',
          orari: ['Lunedì 13:00-16:30', 'Venerdì 09:00-16:30'],
          contatti: ['Tel. 348 44758134', 'E-mail: cvi@ambitocaratebrianza.it'],
        },
        {
          id: 'alzheimer-terzo-settore-macherio',
          nome: 'Alzheimer (collaborazione con Terzo Settore)',
          descrizione:
            'Collaborazione con l’Associazione di Volontariato “Felicemente segui l’Onda” di Carate Brianza per supporto ai caregiver e ai malati di Alzheimer, con orientamento e ascolto.',
          contatti: [
            'E-mail: pua.macherio@asst-brianza.it',
            'Tel. 039 6654573 / 039 6654578',
          ],
        },
      ],
    },
    {
      id: 'domiciliarita-scelta-revoca-macherio',
      titolo: 'Cure domiciliari e scelta/revoca',
      servizi: [
        {
          id: 'cure-domiciliari-macherio',
          nome: 'Cure domiciliari',
          descrizione:
            'Prestazioni sociosanitarie integrate a domicilio per persone in condizione di fragilità/non autosufficienza, attivate su indicazione del medico e declinate nel PAI, erogate da enti accreditati pubblici e privati.',
          contatti: [
            'E-mail: pua.macherio@asst-brianza.it',
            'Tel. 039 6654573 - 039 6654549 - 039 6654197',
          ],
          prestazioni: [
            'Prelievi ematici',
            'Medicazioni',
            'Sostituzione di catetere vescicale',
            'Gestione accessi vascolari e stomie',
            'Trattamenti riabilitativi',
          ],
        },
        {
          id: 'scelta-revoca-macherio',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Sportello Istanze Online Cittadino (SIOC) con supporto telefonico per fissare appuntamento allo sportello o utilizzo di prenotazione regionale/App Salutile.',
          contatti: [
            'SIOC: https://sioc.asst-brianza.it',
            'Numero verde regionale: 800.638.638 (rete fissa)',
            'Numero rete mobile: 02.99.95.99',
            'Prenota online: https://prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
          prestazioni: [
            'Iscrizioni al Servizio Sanitario Regionale',
            'Esenzioni per patologia, reddito e status di invalidità',
            'Scelta e revoca Medico Medicina Generale del Medico di Medicina Generale e del Pediatra di Libera Scelta',
            'Codici PIN/PUK',
          ],
        },
      ],
    },
    {
      id: 'ifec-continuita-macherio',
      titolo: 'IFeC e continuità assistenziale',
      servizi: [
        {
          id: 'ifec-macherio',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Ambulatorio dedicato all’assistenza dei pazienti e dei caregiver che necessitano di interventi tecnico-infermieristici, prevenzione ed educazione all’auto-cura in accordo con MMG/PLS.',
          orari: ['Presenza IFeC: 08:00-20:00', 'Ambulatorio: lunedì-venerdì 09:30-18:30'],
          contatti: ['Tel. 039 6654574', 'E-mail: amb.ifecmacherio@asst-brianza.it'],
          accesso: 'Accesso su impegnativa MMG e prenotazione tramite Front Office e CUP.',
        },
        {
          id: 'continuita-assistenziale-pediatrica-macherio',
          nome: 'Continuità Assistenziale Pediatrica',
          descrizione:
            'Assistenza pediatrica in fascia d’età 0-14 anni tramite centrale operativa unica.',
          contatti: ['Tel. 116117'],
          accesso: 'Accesso esclusivamente su prenotazione telefonica al 116117.',
        },
        {
          id: 'continuita-assistenziale-adulti-macherio',
          nome: 'Continuità Assistenziale',
          descrizione:
            'Assistenza sanitaria della medicina generale e pediatria nelle ore notturne, prefestive e festive per bisogni non differibili; attivazione tramite numero europeo armonizzato 116117.',
          contatti: ['Tel. 116117'],
          orari: ['Da lunedì a venerdì: 19:00-08:00', 'Sabato, domenica e festivi: H24'],
          note: ['Contattare il 116117 prima di presentarsi in ambulatorio di continuità assistenziale.'],
        },
      ],
    },
    {
      id: 'medico-diurno-specialistica-macherio',
      titolo: 'Ambulatorio medico diurno e specialistica',
      servizi: [
        {
          id: 'ambulatorio-medico-diurno-macherio',
          nome: 'Ambulatorio Medico Diurno',
          descrizione:
            'Assistenza medica di primo livello (senza sostituire MMG/PLS) con accesso tramite 116117 e Centrale Unica Diurna; possibile consulto da remoto e invio all’ambulatorio diurno più vicino.',
          orari: ['Attivo 7 giorni su 7: 08:00-20:00'],
          contatti: ['Numero Europeo Armonizzato: 116117'],
          note: ['Gli assistiti ricevono via SMS un link per scaricare la relazione sanitaria.'],
        },
        {
          id: 'medicina-specialistica-macherio',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG per favorire il confronto diretto con il Medico Specialista e una presa in carico condivisa.',
          prestazioni: [
            'Diabetologia',
            'Pneumologia',
            'Neurologia',
            'Oculistica',
            'Geriatria',
            'Cardiologia',
            'Neuropsicologia',
          ],
          accesso: 'Accesso con impegnativa del Medico Curante e prenotazione presso Front Office e CUP o CUP aziendali.',
        },
      ],
    },
    {
      id: 'psicologia-sportelli-macherio',
      titolo: 'Psicologia e sportelli',
      servizi: [
        {
          id: 'psicopatologia-digitale-macherio',
          nome: 'Ambulatorio Psicopatologia Digitale',
          descrizione:
            'Ambulatorio dedicato ai disturbi psichici emergenti legati all’uso disfunzionale dei dispositivi digitali (smartphone, social network, videogiochi), con impatto su competenze emotive/relazionali e sistemi familiari.',
          accesso: 'Accesso spontaneo e libero da parte degli interessati.',
          orari: ['Martedì e mercoledì 09:00-16:30', 'Giovedì 14:00-16:30'],
          contatti: ['E-mail: amb.psicopatologiadigitale@asst-brianza.it'],
        },
        {
          id: 'sportello-informatico-macherio',
          nome: 'Sportello Informatico (SI)',
          descrizione:
            'Sportello di aiuto e supporto informatico (prenotazione domande online, ottenimento SPID, ecc.) in collaborazione con l’Ambito di Carate Brianza.',
          orari: ['Lunedì mattina: 09:00-13:00'],
          contatti: ['Tel. 320 5725102', 'E-mail: sportello@ambitocaratebrianza.it'],
        },
        {
          id: 'psicologia-cure-primarie-macherio',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio sui bisogni psico-emotivi (difficoltà emotive, ansioso-depressive, eventi di vita) e promozione di benessere/agio psicologico, con particolare attenzione a bambini, adolescenti e genitori.',
          accesso:
            'Accesso libero e gratuito senza impegnativa, scrivendo a psicologiadicomunita@asst-brianza.it con dati anagrafici, comune di residenza, MMG/PLS, motivo richiesta e contatti.',
          orari: ['Ambulatorio aperto da lunedì a venerdì: 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico mirato al potenziamento delle risorse personali',
            'Percorsi di terapia di gruppo',
          ],
        },
      ],
    },
  ],
};

export const casaDellaComunitaMacherio = casaDellaCOmunitaMacherio;

export const casaDellaCOmunitaNovaMilanese: CasaDellaComunita = {
  nome: 'Casa della Comunità di Nova Milanese',
  citta: 'Nova Milanese (MB)',
  indirizzo: 'Via Giussani, 11 - Nova Milanese (MB)',
  sitoWeb: 'www.asst-brianza.it',
  sezioneTerritoriale: 'Distretto di Desio',
  sezioneDistrettuale: 'ASST Brianza',
  attiva: 1,
  posizione: { lat: 45.5779, lng: 9.1827 },
  sezioni: [
    {
      id: 'presentazione-nova-milanese',
      titolo: 'La Casa di Comunità',
      servizi: [
        {
          id: 'ruolo-cdc-nova-milanese',
          nome: 'Punto unico di riferimento per la salute',
          descrizione:
            'La Casa della Comunità di Nova Milanese è il punto di accesso ai servizi sanitari e sociosanitari del territorio.',
          contatti: [
            'URP - Distretto Desio: Tel. 039.233.5319/20',
            'E-mail: urp.distrdesio@asst-brianza.it',
          ],
        },
      ],
    },
    {
      id: 'front-office-cup-nova-milanese',
      titolo: 'Front Office, CUP e scelta/revoca',
      servizi: [
        {
          id: 'front-office-cdc-nova-milanese',
          nome: 'Front Office e Centri Unici di Prenotazione (CUP)',
          descrizione:
            'Sportello per informazioni, prenotazioni appuntamenti per ambulatori di medicina specialistica e diagnostica di base e ambulatorio IFeC; pagamento ticket (se dovuto) per prestazioni afferenti alla CdC; Scelta e revoca Medico Medicina Generale MMG ed esenzioni per patologia; accettazione e prenotazione prelievi ematici.',
          orari: ['Sportello aperto da lunedì a venerdì: 08:00-16:00', 'Contatto telefonico: 13:30-15:30 (lunedì-venerdì)'],
          contatti: ['Tel. 0362 383940', 'E-mail: front-office-cdc.nova@asst-brianza.it'],
        },
        {
          id: 'scelta-revoca-nova-milanese',
          nome: 'Scelta e revoca Medico Medicina Generale',
          descrizione:
            'Sportello Istanze Online Cittadino (SIOC); in alternativa prenotazione appuntamento allo sportello tramite canali regionali o App Salutile.',
          contatti: [
            'SIOC: https://sioc.asst-brianza.it',
            'Numero verde regionale: 800.638.638 (rete fissa)',
            'Numero da rete mobile: 02.99.95.99',
            'Prenota online: https://www.prenotasalute.regione.lombardia.it/prenotaonline/',
          ],
        },
      ],
    },
    {
      id: 'presa-in-carico-nova-milanese',
      titolo: 'Presa in carico territoriale e IFeC',
      servizi: [
        {
          id: 'pua-nova-milanese',
          nome: 'Punto Unico di Accesso (PUA)',
          descrizione:
            'Accesso diretto dell’utente e/o caregiver per orientamento e valutazione integrata socio-sanitaria del bisogno di salute; supporto nell’attivazione dei servizi per cittadini in situazione di fragilità con presa in carico nella rete sociosanitaria in ambito ambulatoriale e domiciliare; valutazione e gestione richieste di cure domiciliari.',
          orari: ['Apertura al pubblico: lunedì-venerdì 08:30-16:00'],
          contatti: [
            'Tel. Infermiere di Famiglia e Comunità: 0362 383665',
            'Tel. Assistente Sociale: 0362 383664',
            'Tel. Cure Domiciliari: 0362 383663',
            'E-mail: pua.nova@asst-brianza.it',
          ],
        },
        {
          id: 'ifec-nova-milanese',
          nome: 'Infermieri di Famiglia e di Comunità (IFeC)',
          descrizione:
            'Ambulatorio dedicato all’assistenza delle persone e dei caregiver che necessitano di interventi tecnico-infermieristici e di interventi educativi finalizzati all’apprendimento di competenze e comportamenti utili al mantenimento e alla promozione dello stato di salute.',
          orari: ['Lunedì-venerdì 08:30-15:30'],
          contatti: ['Tel. 0362 383662', 'E-mail: amb.ifecnova@asst-brianza.it'],
          accesso: 'Accesso con impegnativa MMG/Medico Specialista e prenotazione presso Front Office e CUP.',
        },
      ],
    },
    {
      id: 'specialistica-prelievi-nova-milanese',
      titolo: 'Specialistica, diagnostica e punto prelievi',
      servizi: [
        {
          id: 'medicina-specialistica-nova-milanese',
          nome: 'Servizi di medicina specialistica e diagnostica ambulatoriale',
          descrizione:
            'Valutazioni specialistiche su richiesta MMG orientate a favorire il confronto diretto tra Medico di Medicina Generale e Medico Specialista, per una presa in carico condivisa.',
          prestazioni: [
            'Fisiatria',
            'Geriatria',
            'Pneumologia',
            'Diabetologia',
            'Epatologia',
            'Ecografie tiroide e addome',
            'Neuropsicologia',
          ],
          accesso: 'Accesso con impegnativa del Medico Curante e prenotazione presso il Front Office.',
        },
        {
          id: 'punto-prelievi-nova-milanese',
          nome: 'Punto prelievi',
          descrizione:
            'Accesso senza appuntamento con impegnativa; fascia dedicata per informazioni e ritiro contenitori vuoti per raccolta materiali biologici.',
          orari: ['Lunedì-venerdì 07:30-09:30 (prelievi)', 'Lunedì-venerdì 09:00-10:00 (informazioni/ritiro contenitori)'],
        },
      ],
    },
    {
      id: 'protesica-consultorio-psicologia-nova-milanese',
      titolo: 'Protesica, consultorio e psicologia',
      servizi: [
        {
          id: 'protesica-invalidita-nova-milanese',
          nome: 'Protesica e invalidità',
          descrizione: 'Accesso telefonico o via e-mail ai servizi dedicati del Distretto di Desio.',
          orari: ['Da lunedì a venerdì: 09:00-12:00'],
          contatti: [
            'Protesica maggiore: Tel. 039.2335348 - E-mail: protesica.desio@asst-brianza.it',
            'Protesica minore: Tel. 039.2335331 - E-mail: ausili.desio@asst-brianza.it',
            'Ausili per assorbenza: Tel. 039.2335329 (martedì e giovedì 09:00-12:00) - E-mail: assorbenza.desio@asst-brianza.it',
            'Ufficio Invalidi: Tel. 0362 383928 - 0362 383931 - E-mail: invalidi.distrdesio@asst-brianza.it',
          ],
        },
        {
          id: 'consultorio-familiare-nova-milanese',
          nome: 'Consultorio familiare',
          descrizione:
            'Interventi di prevenzione e assistenza sanitaria, psicologica e sociale a tutela della salute della donna, della coppia e della famiglia.',
          accesso: 'Accesso libero il martedì e mercoledì; su appuntamento da lunedì a venerdì.',
          orari: ['Martedì 09:00-12:00 e 14:00-16:00', 'Mercoledì 09:00-12:00'],
          contatti: ['Tel. 0362 383937', 'E-mail: consultorio.novamilanese@asst-brianza.it'],
        },
        {
          id: 'psicologia-cure-primarie-nova-milanese',
          nome: 'Psicologia delle Cure Primarie e di Comunità',
          descrizione:
            'Servizio dedicato ai bisogni psico-emotivi (difficoltà emotive, condizioni ansioso-depressive, difficoltà psicologiche legate agli eventi di vita) e alla promozione del benessere e dell’agio psicologico, con attenzione a bambini, adolescenti e genitori.',
          accesso:
            'Accesso libero e gratuito senza impegnativa del medico, scrivendo una mail con dati anagrafici, comune di residenza, medico/pediatra di riferimento, motivo richiesta, contatto mail e telefonico.',
          orari: ['Ambulatorio aperto da lunedì a venerdì: 08:30-16:30'],
          contatti: ['E-mail: psicologiadicomunita@asst-brianza.it'],
          prestazioni: [
            'Valutazioni psicologiche nei disturbi emotivi comuni',
            'Supporto alla famiglia e alla persona',
            'Sostegno psicologico mirato al potenziamento delle risorse personali',
            'Percorsi di terapia di gruppo',
          ],
        },
      ],
    },
  ],
};

export const casaDellaComunitaNovaMilanese = casaDellaCOmunitaNovaMilanese;

export const casaDellaCOmunitaAgrate: CasaDellaComunita = {
  nome: 'Casa della Comunità di Agrate Brianza',
  citta: 'Agrate Brianza (MB)',
  indirizzo: 'Via Lecco - Agrate Brianza (MB)',
  sitoWeb: '',
  sezioneTerritoriale: '',
  sezioneDistrettuale: '',
  attiva: 0,
  posizione: { lat: 45.5811, lng: 9.3554 },
  //todo: coordinate non precie
  sezioni: [],
};

export const casaDellaComunitaAgrate = casaDellaCOmunitaAgrate;

export const casaDellaCOmunitaMonzaViaLucaDellaRobbia: CasaDellaComunita = {
  nome: 'Casa della Comunità di Monza (Via Luca della Robbia)',
  citta: 'Monza (MB)',
  indirizzo: 'Via Luca della Robbia - Monza (MB)',
  sitoWeb: '',
  sezioneTerritoriale: '',
  sezioneDistrettuale: '',
  attiva: 0,
  posizione: { lat: 45.57950, lng: 9.30233 },
  sezioni: [],
};

export const casaDellaComunitaMonzaViaLucaDellaRobbia = casaDellaCOmunitaMonzaViaLucaDellaRobbia;

export const casaDellaCOmunitaMonzaViaBorgazzi: CasaDellaComunita = {
  nome: 'Casa della Comunità di Monza (Via Borgazzi)',
  citta: 'Monza (MB)',
  indirizzo: 'Via Borgazzi - Monza (MB)',
  sitoWeb: '',
  sezioneTerritoriale: '',
  sezioneDistrettuale: '',
  attiva: 0,
  posizione: { lat: 45.5669, lng: 9.2621 },
  sezioni: [],
};

export const casaDellaComunitaMonzaViaBorgazzi = casaDellaCOmunitaMonzaViaBorgazzi;

